// "use client";
// import { Link, useNavigate } from "react-router-dom";
// import { useState, useEffect, useRef } from "react";
// import Banner from "../components/banner";
// import Navigation from "../components/navigation";
// import { FiArrowRight, FiAward, FiBook, FiBriefcase, FiChevronLeft, FiChevronRight, FiClock, FiGlobe, FiMic, FiStar, FiUsers } from "react-icons/fi";
// import { FaGlobeAsia } from "react-icons/fa";
// // import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
// import {
//   setStoreReduxGallery,
//   setStoreReduxText,
//   setStoreReduxVideo,
// } from "../../reducer/gallerySlice";

// const homeImages = [
//   "./1.jpg",
//   "./2.jpg",
//   "./3.jpg",
//   "./4.jpg",
//   "./5.jpg",
//   "./6.jpg",
//   "./7.jpg",
//   "./8.jpg",
// ];

// function PlayIcon({ className }) {
//   return (
//     <svg
//       className={className}
//       fill="none"
//       viewBox="0 0 24 24"
//       stroke="currentColor"
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeWidth={2}
//         d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
//       />
//     </svg>
//   );
// }

// function SkeletonBox({ className }) {
//   return (
//     <div
//       className={`bg-gray-700/50 animate-pulse rounded-lg ${className}`}
//     ></div>
//   );
// }

// function SkeletonText({ className }) {
//   return (
//     <div className={`bg-gray-600/50 animate-pulse rounded ${className}`}></div>
//   );
// }

// export default function HomePage() {
//   // const backend_domain_name = `https://bicadmin.z256600-ll9lz.ps02.zwhhosting.com`;
//   const new_backend_domain_name = `https://bi.oasisyangonmm.com`
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(true);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [activeLifeSection, setActiveLifeSection] = useState(0);
//   const [activeCategory, setActiveCategory] = useState("all");
//   // const ReduxGallerySection = useSelector((store) => store.galleries);
//   const [galleries, setGalleries] = useState([]);
//   const [videos, setVideos] = useState([]);
//   const [galleryText, setGalleryText] = useState([]);
//  const [isCarouselVisible, setIsCarouselVisible] = useState(false);
// const carouselRef = useRef(null);

//   const sectionRefs = useRef([]);
//   const teachers = [
//   {
//     name: "Mr. Iqbal",
//     occupation: "Biology Teacher",
//     image: "https://bic-bangkok.vercel.app/teachers/Mr.%20Iqbal.jpg",
//     qualifications: [
//       "MSc Modelling for Global Health - University of Oxford",
//       "BSc Human Genetics - University College London"
      
//     ],
//     experience: [
      
//       "3+ Years of teaching experience in Biology and Chemistry",
//       "A-Level Foundation, NCUK, and OSSD programs"
//     ]
//   },
//   {
//     name: "Ms. Hkwan Ra",
//     occupation: "Business, Economic and Accounting Teacher",
//     image: "https://bic-bangkok.vercel.app/teachers/Ms.%20Hkwan%20Ra.jpg",
//     qualifications: [
//       "Dip in International Business Law (ACTD, USA)",
//       "MBA (IES, France) | M.Ed (IBES, France)",
//       "ACCA Part 2 (UK) | B.Com (MUE, Myanmar)"
//     ],
//     experience: [
//       "10+ Years of teaching experiences in Businesses, Economic and Accounting",
//       "2 years in IBDP and 8 years in A-Levels"
//     ]
//   },

//   {
//     name: "Mr. Roland",
//     occupation: "Physics Teacher",
//     image: "https://bic-bangkok.vercel.app/teachers/Mr.%20Roland.jpg",
//     qualifications: [
//       "PhD Thesis (Physics) - University of Yangon",
//       "MSc Physics - Yandanabon University",
//       "BSc (Honours) Physics - Bago University"
//     ],
//     experience: [
//       "15+ Years of teaching experience in Physics"
//     ]
//   },
//   {
//     name: "Dr. Khine Min Min Oo",
//     occupation: "Mathematics Teacher",
//     image: "https://bic-bangkok.vercel.app/teachers/Dr.%20Khine%20Min%20Min%20Oo.jpg",
//     qualifications: [
//       "PhD - Zhejiang Normal University, China",
//       "MSc & BSc - Taunggyi University"
//     ],
//     experience: [
//       "Over 13 years of teaching experience"
//     ]
//   },
//    {
//     name: "Mr. Steven",
//     occupation: "Business Teacher",
//     image: "https://bic-bangkok.vercel.app/teachers/Mr.%20Steven.jpg",
//     qualifications: [
//       "Double Top Paper Prize Awardee (ABE, UK) ",
//       "MSc in Marketing - Leeds Business School (UK)",
//       "MBA - University of Northampton (UK)",
//       "Level 6 Graduate Diploma in Business Management (ABE, UK)",
//       "Double Top Paper Prize Awardee (ABE, UK)"
//     ],
//     experience: [
//       "4+ Years of teaching Business subjects in private universities"
//     ]
//   },
//   {
//     name: "Mr. Si Thu Nyein",
//     occupation: "Business Teacher",
//     image: "https://bic-bangkok.vercel.app/teachers/Mr.%20Si%20Thu%20Nyein.jpg",
//     qualifications: [
//       "BSc (Hons) Mechanical Engineering - Coventry University (UK)"
//     ],
//     experience: [
//       "Over 5 years of teaching experience (GED)"
//     ]
//   },
//   {
//     name: "Mr. Pyae Sone Tun",
//     occupation: "Business Teacher",
//     image: "https://bic-bangkok.vercel.app/teachers/Mr.Pyae%20Sone%20Tun.png",
//     qualifications: [
//       "Bachelor of Electrical and Electronics Engineering (Hons) - University of East London",
//       "Level 7 of Educational Management and Leadership (Ongoing)"
//     ],
//     experience: [
//       "6+ years of teaching experience in IGCSE O-Level and GED (Mathematics)",
//       "4+ years of teaching experience in University Entrance Exams",
//       "1+ year of teaching experience in Thailand"
//     ]
//   }

// ];


//   const lifeSections = [
//     {
//       title: "Cultural Immersion",
//       description:
//         "Immerse yourself in Thai culture while maintaining your global perspective. Our students experience the rich traditions, festivals, and customs of Thailand through organized cultural activities and community engagement.",
//       image: "https://bic-bangkok.vercel.app/cultural.webp",
//       details: [
//         "Traditional Thai festivals and celebrations",
//         "Cultural exchange programs with local communities",
//         "Language immersion opportunities",
//         "Historical site visits and cultural tours",
//       ],
//     },
//     {
//       title: "Extracurricular Activities",
//       description:
//         "From sports teams to academic clubs, drama productions to community service projects. Our diverse range of activities ensures every student finds their passion and develops leadership skills.",
//       image: "https://bic-bangkok.vercel.app/extra.webp",
//       details: [
//         "Sports teams and fitness programs",
//         "Academic clubs and competitions",
//         "Drama and arts productions",
//         "Community service initiatives",
//       ],
//     },
//     {
//       title: "Build Lifelong Memories",
//       description:
//         "Create unforgettable experiences with classmates from around the world. Our campus events, international trips, and graduation celebrations become cherished memories that last a lifetime.",
//       image: "https://bic-bangkok.vercel.app/memories.webp",
//       details: [
//         "International student exchange programs",
//         "Campus events and celebrations",
//         "Graduation ceremonies and achievements",
//         "Alumni network connections",
//       ],
//     },
//     {
//       title: "Accommodation",
//       description:
//         "We offer a variety of safe and modern living options, including on-campus residences and off-campus housing with trusted partners. All accommodations are equipped with the amenities needed to create a comfortable and productive living environment.",
//       image: "https://bic-bangkok.vercel.app/accomodation.webp",
//       details: [
//         "On-campus residences with 24/7 security",
//         "Off-campus housing with trusted partners",
//         "Modern amenities and comfortable furnishings",
//         "Study spaces and recreational facilities",
//       ],
//     },
//   ];
// const [isTransitioning, setIsTransitioning] = useState(true);

// //   const students = [
// //   {
// //     name: "Swan Htet Nay Khaing",
// //     program: "A-Level",
// //     batch: "1",
// //     image: "swan-htet.jpg", // Replace with actual image URL
// //     universities: [
// //       { name: "University of Cambridge", logo: "https://your-image-host.com/cambridge-logo.png" },
// //       { name: "University of Toronto", logo: "https://your-image-host.com/toronto-logo.png" }
// //     ]
// //   },
// //   {
// //     name: "May Thway Ko",
// //     program: "OSSD",
// //     batch: "1",
// //     image: "maythweko.jpg", // Replace with actual image URL
// //     universities: [
// //       { name: "Zhejiang Medical University", logo: "https://your-image-host.com/zhejiang-logo.png" }
// //     ]
// //   },
// //   {
// //     name: "Yati Su Lwin",
// //     program: "OSSD",
// //     batch: "1",
// //     image: "yati.jpg", // Replace with actual image URL
// //     universities: [
// //       { name: "Queen's University", logo: "https://your-image-host.com/queens-logo.png" },
// //       { name: "Western University", logo: "https://your-image-host.com/western-logo.png" },
// //       { name: "University of Guelph", logo: "https://your-image-host.com/guelph-logo.png" },
// //       { name: "Carleton University", logo: "https://your-image-host.com/carleton-logo.png" }
// //     ]
// //   },
// //   {
// //     name: "Min Khant Thaw",
// //     program: "OSSD",
// //     batch: "2",
// //     image: "minkhant.jpg", // Replace with actual image URL
// //     universities: [
// //       { name: "Seneca Polytechnic", logo: "https://your-image-host.com/seneca-logo.png" }
// //     ]
// //   },
// //   {
// //     name: "Kaung Set Lin",
// //     program: "OSSD",
// //     batch: "2",
// //     image: "kaungset.jpg", // Replace with actual image URL
// //     universities: [
// //       { name: "City St George's University of London", logo: "https://your-image-host.com/city-london-logo.png" },
// //       { name: "Brunel University London", logo: "https://your-image-host.com/brunel-logo.png" },
// //       { name: "Kingston University London", logo: "https://your-image-host.com/kingston-logo.png" },
// //       { name: "Middlesex University London", logo: "https://your-image-host.com/middlesex-logo.png" }
// //     ]
// //   }
// // ];

// const students = [
//   {
//     name: "Swan Htet Nay Khaing",
//     program: "A-Level",
//     batch: "1",
//     pathway: "",
//     image: "swan-htet.jpg",
//     universities: [
//       { name: "University of Cambridge", logo: "cambridge.jpg" },
//       { name: "University of Toronto", logo: "toronto.webp" }
//     ]
//   },
//   {
//     name: "May Thway Ko",
//     program: "OSSD",
//     batch: "1",
//     pathway: "Medical Pathway",
//     image: "maythweko.jpg",
//     universities: [
//       { name: "Zhejiang Medical University", logo: "zhejiang.webp" }
//     ]
//   },
//   {
//     name: "Yati Su Lwin",
//     program: "OSSD",
//     batch: "1",
//     pathway: "Engineering Pathway",
//     image: "yati.jpg",
//     universities: [
//       { name: "Queen's University", logo: "queen.webp" },
//       { name: "Western University", logo: "western.webp" },
//       { name: "University of Guelph", logo: "guelph.webp" },
//       { name: "Carleton University", logo: "carleton.webp" }
//     ]
//   },
//   {
//     name: "Min Khant Thaw",
//     program: "OSSD",
//     batch: "2",
//     pathway: "Computer Science Pathway",
//     image: "minkhant.jpg",
//     universities: [
//       { name: "Seneca Polytechnic", logo: "seneca.png" }
//     ]
//   },
//   {
//     name: "Kaung Set Lin",
//     program: "OSSD",
//     batch: "2",
//     pathway: "Business Pathway",
//     image: "kaungset.jpg",
//     universities: [
//       { name: "City St George's University of London", logo: "george.jpg" },
//       { name: "Brunel University London", logo: "brunei.jpg" },
//       { name: "Kingston University London", logo: "kingston.jpg" },
//       { name: "Middlesex University London", logo: "middlesex.webp" }
//     ]
//   },
//   {
//     name: "Min Hein Khant",
//     program: "OSSD",
//     batch: "2",
//     pathway: "Medical Pathway",
//     image: "minheinkhant.jpg",
//     universities: [
//       { name: "University of Parma", logo: "parma.png" }
//     ]
//   },
//   {
//     name: "Chit Su Naing",
//     program: "OSSD",
//     batch: "2",
//     pathway: "Computer Science Pathway",
//     image: "chitsunaing.jpg",
//     universities: [
//       { name: "University of Sheffield", logo: "sheffield.png" },
//       { name: "University of Southampton", logo: "southampton.png" },
//       { name: "Fraser International College", logo: "fraser.png" }
//     ]
//   }
// ];
// const fetchData = async () => {
//     try {
//       setIsLoading(true);
//       const response = await axios.get(`${new_backend_domain_name}/api/galleries`);
//       if (response.status == 200) {
//         console.log(response.data);
//         setGalleryText(response.data.data.text);
//         setVideos(response.data.data.video);
//         setGalleries(response.data.data.galleries);
//         console.log(response.data.data.text);
//         // dispatch(setReduxMainSponsors(response.data.mainSponsors));
//         // dispatch(setReduxDiamondSponsors(response.data.diamondSponsors));
//         // dispatch(setReduxPrevSponsors(response.data.prevSponsors));
//         // dispatch(setStoreReduxFaq(response.data.faqs));
//       } else {
//         console.log("error");
//       }
//       setIsLoading(false);
//     } catch (error) {
//       console.error("Error in fetchApi:", error);
//       setIsLoading(false);
//     }
//   };
// useEffect(() => {
//   let interval;

//   // Start immediately
//   interval = setInterval(() => {
//     // Only advance if the section is visible
//     if (isCarouselVisible) {
//       setCurrentSlide((prev) => (prev + 1) % students.length);
//     }
//   }, 5000);

//   return () => {
//     if (interval) {
//       clearInterval(interval);
//     }
//   };
// }, [isCarouselVisible, students.length]);

//   useEffect(() => {
//     fetchData();
//     window.scrollTo(0, 0);

//     const timer = setTimeout(() => {
//       setIsLoading(false);
//     }, 8000);

//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//   if (isLoading) return;

//   const currentElement = carouselRef.current;
//   if (!currentElement) return;

//   const observer = new IntersectionObserver(
//     (entries) => {
//       entries.forEach((entry) => {
//         setIsCarouselVisible(entry.isIntersecting);
//       });
//     },
//     {
//       threshold: 0.1,
//       rootMargin: "0px 0px -50px 0px",
//     }
//   );

//   observer.observe(currentElement);

//   return () => {
//     observer.unobserve(currentElement);
//   };
// }, [isLoading]);

//   return (
//     <div
//       className="relative min-h-screen font-lora"
//       style={{
//         overflowX: "hidden",
//         maxWidth: "100vw",
//         width: "100%",
//       }}
//     >
//       <Navigation />

//       <Banner
//         title="Welcome to Bridge International  Bangkok"
//         subtitle="Discover an unparalleled educational experience in the heart of Bangkok."
//       />

//       <div style={{ paddingTop: "10px" }}>
//         {isLoading ? (
//           <div className="space-y-0">
//             <section className="w-full flex flex-col md:flex-row items-stretch">
//               <div className="w-full md:w-1/2">
//                 <SkeletonBox className="w-full h-96 md:h-[500px]" />
//               </div>
//               <div className="w-full md:w-1/2 bg-dark-blue p-6 md:p-10 flex flex-col justify-center space-y-4">
//                 <SkeletonText className="h-10 w-3/4" />
//                 <SkeletonText className="h-4 w-full" />
//                 <SkeletonText className="h-4 w-5/6" />
//                 <SkeletonText className="h-4 w-4/5" />
//                 <div className="flex gap-4 pt-6">
//                   <SkeletonBox className="h-12 w-32" />
//                   <SkeletonBox className="h-12 w-32" />
//                 </div>
//               </div>
//             </section>

//             <section className="w-full bg-grey-blue flex flex-wrap">
//               {[1, 2, 3, 4].map((i) => (
//                 <div
//                   key={i}
//                   className="w-1/2 md:w-1/4 p-4 flex justify-center items-center"
//                 >
//                   <SkeletonBox className="h-20 w-32" />
//                 </div>
//               ))}
//             </section>

//             {[1, 2, 3].map((i) => (
//               <section
//                 key={i}
//                 className={`w-full flex flex-col ${
//                   i % 2 === 0 ? "md:flex-row-reverse" : "md:flex-row"
//                 } items-stretch`}
//               >
//                 <div className="w-full md:w-1/2">
//                   <SkeletonBox className="w-full h-96 md:h-[400px]" />
//                 </div>
//                 <div className="w-full md:w-1/2 bg-dark-blue p-6 md:p-10 flex flex-col justify-center space-y-4">
//                   <SkeletonText className="h-8 w-2/3" />
//                   <SkeletonText className="h-4 w-full" />
//                   <SkeletonText className="h-4 w-5/6" />
//                   <SkeletonText className="h-4 w-3/4" />
//                   <SkeletonBox className="h-12 w-36 mt-6" />
//                 </div>
//               </section>
//             ))}

//             <section className="w-full flex flex-col md:flex-row items-start py-8 md:py-14 px-4 md:px-6 gap-8 md:gap-12 bg-dark-blue">
//               <div className="w-full md:w-1/2 flex flex-col space-y-6">
//                 <SkeletonText className="h-12 w-3/4" />
//                 <SkeletonText className="h-6 w-1/2" />
//                 <SkeletonText className="h-4 w-full" />
//                 <SkeletonText className="h-4 w-5/6" />
//                 <SkeletonBox className="h-12 w-48 mt-6" />
//               </div>
//               <div className="w-full md:w-1/2 flex flex-col gap-3">
//                 <SkeletonBox className="aspect-video w-full rounded-xl" />
//                 <div className="grid grid-cols-3 gap-3">
//                   {[1, 2, 3].map((i) => (
//                     <SkeletonBox key={i} className="aspect-video rounded-lg" />
//                   ))}
//                 </div>
//               </div>
//             </section>

//             <section className="w-full py-12 md:py-20 px-4 md:px-6 bg-gradient-to-br from-dark-blue via-dark-primary to-dark-blue">
//               <div className="max-w-7xl mx-auto">
//                 <div className="text-center mb-12">
//                   <SkeletonText className="h-12 w-1/2 mx-auto mb-4" />
//                   <SkeletonText className="h-6 w-3/4 mx-auto" />
//                 </div>
//                 <div className="space-y-16">
//                   {[1, 2, 3].map((i) => (
//                     <div
//                       key={i}
//                       className={`flex flex-col ${
//                         i % 2 === 0 ? "lg:flex-row-reverse" : "lg:flex-row"
//                       } gap-8 lg:gap-12 items-center`}
//                     >
//                       <div className="w-full lg:w-1/2">
//                         <SkeletonBox className="aspect-video w-full rounded-2xl mb-4" />
//                         <SkeletonBox className="aspect-video w-full rounded-xl" />
//                       </div>
//                       <div className="w-full lg:w-1/2 space-y-6">
//                         <div className="flex items-center gap-3">
//                           <SkeletonBox className="h-6 w-20" />
//                           <SkeletonText className="h-8 w-1/2" />
//                         </div>
//                         <SkeletonText className="h-6 w-full" />
//                         <SkeletonText className="h-4 w-5/6" />
//                         <SkeletonText className="h-4 w-4/5" />
//                         <div className="grid grid-cols-2 md:grid-cols-4 gap-3 pt-4">
//                           {[1, 2, 3, 4].map((j) => (
//                             <SkeletonBox
//                               key={j}
//                               className="aspect-square rounded-xl"
//                             />
//                           ))}
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </section>
//           </div>
//         ) : (
//           <div className="space-y-0">
//             <section className="w-full flex flex-col md:flex-row items-stretch">
//               {/* Left side: just an image */}
//               <div className="w-full md:w-1/2">
//                 <img
//                   src="https://bic-bangkok.vercel.app/signage.jpg"
//                   alt="Bridge International Bangkok"
//                   className="w-full h-full object-cover"
//                 />
//               </div>

//               {/* Right side: background image + overlay + text */}
//               <div
//                 className="w-full md:w-1/2 relative bg-cover bg-center"
//                 style={{
//                   backgroundImage: "url('./bridge-bg.jpg')",
//                 }}
//               >
//                 {/* Darker overlay */}
//                 <div className="absolute inset-0 bg-dark-blue bg-opacity-80"></div>

//                 {/* Text content */}
//                 <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
//                   <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
//                     What is Bridge International?
//                   </h2>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     Bridge International (BI) is a premier educational
//                     institution in Bangkok, dedicated to guiding ambitious
//                     students toward top universities around the world.
//                   </p>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     We serve as a bridge between potential and opportunity,
//                     helping students gain the academic foundation, skills, and
//                     confidence needed for admission into leading universities in
//                     the UK, the United States, Australia, New Zealand, Canada,
//                     Europe, and beyond.
//                   </p>
//                   <div className="flex flex-col sm:flex-row gap-3 md:gap-4 pt-4">
//                     <Link
//                       to="/about"
//                       className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold text-center rounded-lg shadow-md transition hover-lift font-manrope text-sm md:text-base"
//                     >
//                       Learn More
//                     </Link>
//                     <Link
//                       to="/admissions"
//                       className="px-4 md:px-6 py-2 md:py-3 bg-transparent border border-brand-beige text-center hover:bg-brand-beige hover:text-dark-primary text-brand-beige font-semibold rounded-lg transition hover-lift font-manrope text-sm md:text-base"
//                     >
//                       Apply Now
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </section>

//             <section className="w-full bg-grey-blue flex flex-wrap">
//               {[
//                 {
//                   link: "/igcse",
//                   alt: "IGCSE",
//                   src: "https://bic-bangkok.vercel.app/IGCSE.jpg",
//                 },
//                 {
//                   link: '/alevels',
//                   alt: "A Levels",
//                   src: "https://bic-bangkok.vercel.app/alevels.jpg",
//                 },
//                 {
//                  link: "/ossd" ,
//                   alt: "OSSD",
//                   src: "https://bic-bangkok.vercel.app/ossd.jpg",
//                 },
//                 {
//                   link: '/ged',
//                   alt: "GED",
//                   src: "https://bic-bangkok.vercel.app/ged.jpg",
//                 },
//                 {
//                   link: '/ncuk',
//                   alt: "NCUK",
//                   src: "https://www.bi-bangkok.com/ncuk.jpg",
//                 },
//                 {
//                   link: '/university-21',
//                   alt: "University (2+1)",
//                   src: "https://bic-bangkok.vercel.app/un.png"
//                 }
//               ].map(({ alt, src, link }) => (
//                 <div
//                   key={alt}
//                   onClick={()=> {
//                     navigate(`${link}`)
//                   }}
//                   className="w-1/2 md:w-1/6 p-2 bg-grey-blue flex justify-center items-center filter filter grayscale-[40%]  hover:grayscale-0 transition duration-300"
//                 >
//                   <img
//                     src={src || "/placeholder.svg"}
//                     alt={alt}
//                     className="max-w-full max-h-33 object-contain"
//                     loading="lazy"
//                   />
//                 </div>
//               ))}
//             </section>

//             <section className="w-full flex flex-col md:flex-row items-stretch">
//               {/* Left side: just an image */}
//               <div className="w-full md:w-1/2">
//                 <img
//                   // src="https://tse1.mm.bing.net/th/id/OIP.C4y-ifG4Ft1ZZwi0vEepVgHaFD?rs=1&pid=ImgDetMain&o=7&rm=3"
//                   src="https://bic-bangkok.vercel.app/crowd1.jpg"
//                   alt="What we offer"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               {/* Right side: background image + overlay + text */}
//               <div
//                 className="w-full md:w-1/2 relative bg-cover bg-center"
//                 style={{
//                   backgroundImage:
//                     "url('https://bic-bangkok.vercel.app/accommodation1.jpg')",
//                 }}
//               >
//                 {/* Darker overlay */}
//                 <div className="absolute inset-0 bg-black/70 bg-opacity-80"></div>
//                 {/* Text content */}
//                 <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
//                   <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
//                     What We Offer
//                   </h2>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     We provide comprehensive educational programs designed to
//                     prepare students for success at top international
//                     universities. Our expert faculty and proven curriculum
//                     ensure exceptional academic outcomes.
//                   </p>
//                   <ul className="list-disc list-inside font-manrope text-gray-400 max-w-xl space-y-1 text-sm md:text-base">
//                     <li className=" text-brand-beige">
//                       IGCSE, A Levels, OSSD, and GED programs
//                     </li>
//                     <li className=" text-brand-beige">
//                       University application guidance and support
//                     </li>
//                     <li className=" text-brand-beige">
//                       Small class sizes with personalized attention
//                     </li>
//                     <li className=" text-brand-beige">
//                       International faculty with proven expertise
//                     </li>
//                   </ul>
//                   <div className="flex flex-col sm:flex-row gap-3 md:gap-4 pt-4">
//                     <Link
//                       to="/programs"
//                       className="px-4 text-center  md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
//                     >
//                       View Programs
//                     </Link>
//                     <Link
//                       to="/admissions"
//                       className="px-4 text-center md:px-6 py-2 md:py-3 bg-transparent border border-brand-beige hover:bg-brand-beige hover:text-dark-primary text-brand-beige font-semibold rounded-xl transition hover-lift font-manrope text-sm md:text-base"
//                     >
//                       Apply Now
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </section>

//             <section className="w-full flex flex-col md:flex-row-reverse items-stretch">
//               {/* Right side: image */}
//               <div className="w-full md:w-1/2">
//                 <img
//                   src="https://bic-bangkok.vercel.app/lib.jpg"
//                   alt="What we offer"
//                   className="w-full h-full object-cover"
//                 />
//               </div>

//               {/* Left side: text with bg-white/40 */}
//               <div className="w-full md:w-1/2 bg-dark-blue flex flex-col justify-center p-6 md:p-10 space-y-4 md:space-y-6">
//                 <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
//                   University Preparation at BI
//                 </h2>
//                 <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                   At BI, we are committed to fostering academic excellence
//                   through our rigorous University preparation programmes:{" "}
//                   <strong className=" text-brand-red">GED</strong>,{" "}
//                   <strong className=" text-brand-red">IGCSE</strong>, and
//                   <strong className=" text-brand-red"> A Levels</strong> — all
//                   tailored for students aiming to get into top international
//                   universities.
//                 </p>
//                 <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                   Our vibrant campus, expert faculty, and cultural immersion
//                   opportunities make BI the perfect place to achieve your
//                   academic goals and prepare for a global future.
//                 </p>
//               </div>
//             </section>

        

// {/* NCUK Study Centre Section */}
// <section className="w-full flex flex-col md:flex-row bg-dark-blue  items-stretch">
//   {/* Left side - Big Image */}
//   <div className="w-full md:w-1/2">
//     <img
//       src="https://bic-bangkok.vercel.app/studyCenter.jpg"
//       alt="NCUK Study Centre"
//       className="w-full h-full object-cover min-h-[400px] md:min-h-[500px]"
//     />
//   </div>

// {/* Text content */}
// <div className="relative z-10 p-6 md:p-10 flex flex-col bg-dark-blue  justify-center h-full">

//   {/* Logo + Badge */}
//   <div className="flex flex-wrap items-center gap-4 mb-6">
//     <img
//       src="/centre.png"
//       alt="NCUK Logo"
//       className="h-12 md:h-16 object-contain flex-shrink-0"
//     />

//     <div className="px-4 py-1.5 bg-brand-red/20 rounded-full border border-brand-red/40">
//       <span className="text-brand-beige font-manrope font-semibold text-xs uppercase tracking-widest">
//         Official Study Centre
//       </span>
//     </div>
//   </div>

//   {/* Heading */}
//   <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige mb-3">
//     Official <span className="text-brand-red">NCUK</span> Study Centre
//   </h2>

//   {/* Partner */}
//   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl mb-4">
//     in partnership with{" "}
//     <span className="text-brand-beige font-semibold">
//       Dhurakij Pundit University
//     </span>
//   </p>

//   {/* Description */}
//   <p className="text-base md:text-lg font-manrope text-gray-400 max-w-xl leading-relaxed mb-8">
//     Bridge International Bangkok is proud to be an official NCUK Study Centre,
//     offering students a guaranteed pathway to top universities in the UK,
//     Australia, New Zealand, and beyond through our partnership with
//     Dhurakij Pundit University.
//   </p>

//   {/* Buttons */}
//   <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
//     <Link
//       to="/about#ncuk-partnership"
//       className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold text-center rounded-lg shadow-md transition hover-lift font-manrope text-sm md:text-base inline-flex items-center justify-center gap-2"
//     >
//       Read More
//       <FiArrowRight className="w-4 h-4" />
//     </Link>

//   </div>

// </div>
// </section>


//             <section className="w-full flex flex-col md:flex-row items-start py-8 md:py-14 px-4 md:px-6 gap-8 md:gap-12 relative overflow-hidden">
//               <div className="w-full md:w-1/2 flex flex-col mt-4 justify-start">
//                 <h2 className="text-3xl md:text-4xl lg:text-5xl font-lora font-semibold text-brand-beige mb-6 md:mb-8">
//                   Why Choose Us
//                 </h2>
//                 <h3 className="text-xl md:text-2xl font-lora text-brand-beige font-semibold mb-4">
//                   Bridge International Bangkok
//                 </h3>
//                 <p className="text-gray-300 text-base md:text-lg leading-relaxed font-manrope mb-4 md:mb-6">
//                   We offer more than just education — we offer transformation.
//                   With an internationally aligned curriculum and a strong
//                   emphasis on global citizenship, BI Bangkok empowers students
//                   with the knowledge, skills, and confidence to thrive in an
//                   ever-changing world.
//                 </p>
//                 <p className="text-gray-400 text-sm md:text-base leading-relaxed font-manrope">
//                   Our expert educators and inclusive community foster critical
//                   thinking, innovation, and a lifelong passion for learning.
//                   Choosing BI means choosing a future where every student's
//                   potential is unlocked.
//                 </p>
//                 {/* Full-width Button on mobile, fit on desktop */}
//                 <Link
//                   to="/about"
//                   className="w-full md:w-auto inline-flex justify-center items-center px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-brand-red/90 text-white font-manrope font-semibold rounded-xl transition-all duration-300 shadow-md hover:shadow-brand-red/30 mt-6 md:mt-8 hover-lift text-sm md:text-base"
//                 >
//                   Learn More About Us
//                   <svg
//                     className="w-4 h-4 md:w-5 md:h-5 ml-2"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M17 8l4 4m0 0l-4 4m4-4H3"
//                     />
//                   </svg>
//                 </Link>
//               </div>
//               {/* Right Side - Video only, NO BOX */}
//               <div className="w-full md:w-1/2 flex flex-col gap-2">
//                 {/* Main Video */}
//                 <div className="aspect-video rounded-xl overflow-hidden bg-dark-primary">
//                   <iframe
//                     width="100%"
//                     height="100%"
//                     src="https://www.youtube.com/embed/BNA3J24Ed0g"
//                     title="BI Welcoming Message"
//                     frameBorder="0"
//                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                     referrerPolicy="strict-origin-when-cross-origin"
//                     allowFullScreen
//                     className="w-full h-full rounded-lg"
//                   />
//                 </div>
//                 {/* Thumbnails */}
//                 <div className="grid grid-cols-3 gap-2 md:gap-3">
//                   {["BNA3J24Ed0g", "X2WWn2-_mpM", "4edqha3Tb0k"].map(
//                     (id, index) => (
//                       <button
//                         key={id}
//                         onClick={() =>
//                           (document.querySelector(
//                             "iframe"
//                           ).src = `https://www.youtube.com/embed/${id}?autoplay=1`)
//                         }
//                         className="relative aspect-video rounded-lg overflow-hidden border-2 border-white/20 hover:border-brand-beige transition-all group"
//                       >
//                         <img
//                           src={`https://img.youtube.com/vi/${id}/mqdefault.jpg`}
//                           alt={`Video ${index + 1}`}
//                           className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
//                         />
//                         <div className="absolute inset-0 bg-dark-primary/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
//                           <PlayIcon className="w-4 h-4 md:w-6 md:h-6 text-brand-beige" />
//                         </div>
//                       </button>
//                     )
//                   )}
//                 </div>
//               </div>
//             </section>

           
//      {/* <section className="w-full flex flex-col md:flex-row items-stretch">
//               <div className="w-full md:w-1/2">
//                 <img
//                   src="https://bic-bangkok.vercel.app/IGCSE.jpg"
//                   alt="IGCSE Program"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div
//                 className="w-full md:w-1/2 relative bg-cover bg-center"
//                 style={{
//                   backgroundImage: "url('./igcse-bg.jpg')",
//                 }}
//               >
//                 <div className="absolute inset-0 bg-white/40 bg-opacity-80"></div>
//                 <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
//                   <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
//                     IGCSE
//                   </h2>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     Engaging students through discussions, group projects, and
//                     practical applications. Our IGCSE program provides a solid
//                     foundation for advanced studies with internationally
//                     recognized qualifications.
//                   </p>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     Students develop critical thinking skills and gain
//                     comprehensive knowledge across multiple subjects, preparing
//                     them for A Levels and university entrance.
//                   </p>
//                   <div className="flex flex-wrap gap-4 pt-4">
//                     <Link
//                       to="/igcse"
//                       className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
//                     >
//                       Learn More
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </section> */}

// {/*             <section className="w-full flex flex-col-reverse md:flex-row items-stretch">
//               <div
//                 className="w-full md:w-1/2 relative bg-cover bg-center"
//                 style={{
//                   backgroundImage: "url('./ossd-bg.jpg')",
//                 }}
//               >
//                 <div className="absolute inset-0 bg-white/40 bg-opacity-80"></div>
//                 <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
//                   <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
//                     OSSD
//                   </h2>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     With small class sizes, our teachers focus on the unique
//                     needs of each student. The Ontario Secondary School Diploma
//                     offers a flexible pathway to Canadian and international
//                     universities.
//                   </p>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     Students benefit from personalized attention and a
//                     curriculum that emphasizes both academic excellence and
//                     practical skills development.
//                   </p>
//                   <div className="flex flex-wrap gap-4 pt-4">
//                     <Link
//                       to="/ossd"
//                       className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
//                     >
//                       Learn More
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//               <div className="w-full md:w-1/2">
//                 <img
//                   src="https://bic-bangkok.vercel.app/ossd.jpg"
//                   alt="OSSD Program"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//             </section> */}

// {/*             <section className="w-full flex flex-col md:flex-row items-stretch">
//               <div className="w-full md:w-1/2">
//                 <img
//                   src="https://bic-bangkok.vercel.app/alevels.jpg"
//                   alt="A Levels Program"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div
//                 className="w-full md:w-1/2 relative bg-cover bg-center"
//                 style={{
//                   backgroundImage: "url('./alevels-bg.jpg')",
//                 }}
//               >
//                 <div className="absolute inset-0 bg-white/40 bg-opacity-80"></div>
//                 <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
//                   <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
//                     A Levels
//                   </h2>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     Read about the achievements of our students who have gone on
//                     to study at prestigious universities around the world. Our A
//                     Levels program is the gold standard for university
//                     preparation.
//                   </p>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     Students pursue in-depth study in their chosen subjects,
//                     developing the analytical and research skills essential for
//                     university success.
//                   </p>
//                   <div className="flex flex-wrap gap-4 pt-4">
//                     <Link
//                       to="/alevels"
//                       className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
//                     >
//                       Learn More
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </section> */}

// {/*             <section className="w-full flex flex-col-reverse md:flex-row items-stretch">
//               <div
//                 className="w-full md:w-1/2 relative bg-cover bg-center"
//                 style={{
//                   backgroundImage: "url('./ged-bg.jpg')",
//                 }}
//               >
//                 <div className="absolute inset-0 bg-white/40 bg-opacity-80"></div>
//                 <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
//                   <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
//                     GED
//                   </h2>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     Flexible pathway for adult learners seeking to complete
//                     their high school equivalency and advance to higher
//                     education. Our GED program accommodates working
//                     professionals and non-traditional students.
//                   </p>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     With flexible scheduling and comprehensive support, students
//                     can achieve their educational goals while balancing other
//                     life commitments.
//                   </p>
//                   <div className="flex flex-wrap gap-4 pt-4">
//                     <Link
//                       to="/ged"
//                       className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
//                     >
//                       Learn More
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//               <div className="w-full md:w-1/2">
//                 <img
//                   src="https://bic-bangkok.vercel.app/ged.jpg"
//                   alt="GED Program"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//             </section> */}

// {/*             <section className="w-full flex flex-col md:flex-row items-stretch">
//               <div className="w-full md:w-1/2">
//                 <img
//                   src="/ncuk.jpg"
//                   alt="NCUK Program"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div
//                 className="w-full md:w-1/2 relative bg-cover bg-center"
//                 style={{
//                   backgroundImage: "url('./ncuk-bg.jpg')",
//                 }}
//               >
//                 <div className="absolute inset-0 bg-white/40 bg-opacity-80"></div>
//                 <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
//                   <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
//                     NCUK
//                   </h2>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     The NCUK International Foundation Year is your gateway to
//                     top-ranked universities in the UK and worldwide. Designed in
//                     partnership with leading institutions, it ensures students
//                     are fully prepared for undergraduate study abroad.
//                   </p>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     Through a mix of academic excellence, English language
//                     development, and university preparation, NCUK provides a
//                     trusted pathway for ambitious students aiming to succeed
//                     internationally.
//                   </p>
//                   <div className="flex flex-wrap gap-4 pt-4">
//                     <Link
//                       to="/ncuk"
//                       className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
//                     >
//                       Learn More
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </section> */}

// {/*             <section className="w-full flex flex-col-reverse md:flex-row items-stretch">
//   <div className="w-full md:w-2/5 relative">
//     <div className="absolute inset-0 bg-white/40 bg-opacity-80"></div>
//     <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
//       <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
//         University (2+1) Program
//       </h2>
//       <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
// The University (2+1) Program lets students earn a UK Bachelor's degree from the University of Sunderland while studying entirely in Bangkok.
//       </p>
//       <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//      Students learn in an international campus environment with experienced global faculty, modern classrooms, and small class sizes that allow for closer guidance and personal academic support.
//       </p>
//       <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
// This program is perfect for students who want a globally recognized UK degree, an exciting international university experience, and a smart, affordable path toward a successful global career.
//       </p>
//       <div className="flex flex-wrap gap-4 pt-4">
//         <Link
//           to="/university-program"
//           className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
//         >
//           Learn More
//         </Link>
//       </div>
//     </div>
//   </div>
//   <div className="w-full md:w-3/5">
//     <img
//       src="https://bic-bangkok.vercel.app/un.png"
//       alt="University Program"
//       className="w-full h-full object-cover"
//     />
//   </div>
// </section> */}


//             {/* Why Bangkok Section */}
//             <section className="w-full">
//               <div
//                 className="w-full relative bg-cover bg-center py-12 md:py-20"
//                 style={{
//                   backgroundImage: "url('./bangkok-bg.jpg')",
//                 }}
//               >
//                 {/* Darker overlay */}
//                 <div className="absolute inset-0 bg-dark-blue bg-opacity-80"></div>
//                 {/* Text content - centered */}
//                 <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center space-y-6 md:space-y-8">
//                   <h2 className="text-3xl md:text-5xl font-lora font-semibold leading-tight text-brand-beige">
//                     Why Bangkok?
//                   </h2>
//                   <div className="space-y-6 max-w-3xl mx-auto">
//                     <div className="flex items-start space-x-4 text-left">
//                       <div className="w-3 h-3 bg-brand-red rounded-full mt-2 flex-shrink-0"></div>
//                       <p className="text-lg md:text-xl font-manrope text-gray-300">
//                         Bangkok offers a{" "}
//                         <span className="text-brand-beige font-semibold">
//                           safe, accessible, and culturally familiar environment
//                         </span>
//                         , making it the perfect first step for Myanmar students.
//                       </p>
//                     </div>
//                     <div className="flex items-start space-x-4 text-left">
//                       <div className="w-3 h-3 bg-brand-red rounded-full mt-2 flex-shrink-0"></div>
//                       <p className="text-lg md:text-xl font-manrope text-gray-300">
//                         It allows them to{" "}
//                         <span className="text-brand-beige font-semibold">
//                           build independence and adapt gradually
//                         </span>{" "}
//                         before transitioning to the UK.
//                       </p>
//                     </div>
//                     <div className="flex items-start space-x-4 text-left">
//                       <div className="w-3 h-3 bg-brand-red rounded-full mt-2 flex-shrink-0"></div>
//                       <p className="text-lg md:text-xl font-manrope text-gray-300">
//                         With its{" "}
//                         <span className="text-brand-beige font-semibold">
//                           close proximity, parents can easily visit
//                         </span>
//                         , offering added peace of mind.
//                       </p>
//                     </div>
//                     <div className="flex items-start space-x-4 text-left">
//                       <div className="w-3 h-3 bg-brand-red rounded-full mt-2 flex-shrink-0"></div>
//                       <p className="text-lg md:text-xl font-manrope text-gray-300">
//                         As a{" "}
//                         <span className="text-brand-beige font-semibold">
//                           modern, global city with regional comfort
//                         </span>
//                         , Bangkok serves as an ideal launchpad for students to
//                         grow academically and personally on their international
//                         journey.
//                       </p>
//                     </div>
//                   </div>
//                   <div className="flex flex-wrap justify-center gap-4 pt-6">
//                     {/* <Link
//                       to="/about"
//                       className="px-6 md:px-8 py-3 md:py-4 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-base md:text-lg"
//                     >
//                       Discover More
//                     </Link> */}
//                     <Link
//                       to="/enquire"
//                       className="px-6 md:px-8 py-3 md:py-4 bg-transparent border border-brand-beige hover:bg-brand-beige hover:text-dark-primary text-brand-beige font-semibold rounded-xl transition hover-lift font-manrope text-base md:text-lg"
//                     >
//                       Contact Us
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </section>

//             {/* LEARN FROM THE BEST AT BI - Modern Card Layout */}


// <section
//   className="w-full py-16 md:py-24 px-4 md:px-6 relative"
//   style={{ backgroundImage: "url('./shirt.jpg')" }}
// >
//   {/* Darker gray gradient overlay */}
//   <div className="absolute inset-0 bg-gradient-to-br from-gray-900/90 via-black-900/85 to-gray-950/90"></div>
  
//   {/* Subtle texture */}
//   <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_1px_1px,rgba(255,255,255,0.1)_1px,transparent_0)] bg-[size:40px_40px]"></div>

//   <div className="relative z-10 max-w-7xl mx-auto">
//     {/* Header */}
//     <div className="text-center mb-16">
//       <div className="inline-block mb-4 px-4 py-2 bg-brand-red/30 backdrop-blur-sm rounded-lg border border-brand-red/40">
//         <span className="text-brand-beige font-manrope font-semibold text-sm uppercase tracking-wider">
//           Faculty Excellence
//         </span>
//       </div>
//       <h1 className="text-4xl md:text-5xl font-lora font-bold text-gray-300 mb-4 drop-shadow-lg">
//         LEARN FROM OUR EXPERT FACULTY
//       </h1>
//       <div className="w-24 h-1 bg-brand-beige mx-auto mb-6"></div>
//       <p className="text-lg md:text-2xl font-manrope font-bold text-brand-beige leading-relaxed max-w-4xl mx-auto drop-shadow-md">
//         World-class educators dedicated to your academic success
//       </p>
//     </div>

//     {/* Featured Teachers - Full Information */}
//     <div className="space-y-12 mb-16">
  

//       {/* Mr. Iqbal */}
//       <div className="group bg-gray-950 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-gray-700/60 hover:border-brand-beige/50 transition-all duration-300 shadow-2xl shadow-black/50">
//         <div className="flex flex-col md:flex-row md:items-start gap-6 mb-6">
//           <div className="md:w-1/4">
//             <div className="relative">
//               <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden border-2 border-brand-beige/60 mx-auto md:mx-0 shadow-xl bg-gray-700 p-1">
//                 <img
//                   src="https://bic-bangkok.vercel.app/teachers/Mr.%20Iqbal.jpg"
//                   alt="Mr. Iqbal"
//                   className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300 rounded-full"
//                 />
//               </div>
//               <div className="absolute top-0 right-0 md:right-4 bg-brand-red text-white px-4 py-1.5 rounded-full text-sm font-bold shadow-lg">
//                 Featured
//               </div>
//             </div>
//           </div>
//           <div className="md:w-3/4">
//             <div className="flex flex-col sm:flex-row sm:items-center mb-3">
//               <h2 className="text-2xl md:text-3xl font-lora font-semibold text-brand-beige">Mr. Iqbal</h2>
//               <div className="flex items-center mt-2 sm:mt-0 sm:ml-4 space-x-2">
//                 <span className="px-3 py-1 bg-blue-500/40 text-blue-300 text-xs font-bold rounded-full">Oxford</span>
//                 <span className="px-3 py-1 bg-gray-700 text-gray-300 text-xs rounded-full">3+ Years Exp</span>
//               </div>
//             </div>
//             <p className="text-xl text-gray-400 font-manrope mb-6">Biology Teacher</p>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               {/* Qualifications */}
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-300 mb-3 pb-2 border-b border-gray-700 flex items-center">
//                   <FiBook className="w-5 h-5 mr-2 text-brand-beige" />
//                   Qualifications
//                 </h3>
//                 <ul className="space-y-3">
//                   {teachers[0].qualifications.map((qual, index) => (
//                     <li key={index} className="flex items-start group hover:bg-gray-700/50 p-2 rounded-lg transition-colors">
//                       <div className="w-5 h-5 bg-brand-red/30 rounded-full flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
//                         <span className="text-brand-beige text-xs">✓</span>
//                       </div>
//                       <span className="text-gray-400 group-hover:text-gray-300 transition-colors">{qual}</span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
              
//               {/* Experience */}
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-300 mb-3 pb-2 border-b border-gray-700 flex items-center">
//                   <FiBriefcase className="w-5 h-5 mr-2 text-blue-400" />
//                   Experience
//                 </h3>
//                 <ul className="space-y-3">
//                   {teachers[0].experience.map((exp, index) => (
//                     <li key={index} className="flex items-start group hover:bg-gray-700/50 p-2 rounded-lg transition-colors">
//                       <div className="w-5 h-5 bg-blue-500/30 rounded-full flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
//                         <span className="text-blue-300 text-xs">★</span>
//                       </div>
//                       <span className="text-gray-400 group-hover:text-gray-300 transition-colors">{exp}</span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>


//     </div>

//     {/* All Other Teachers */}
//     <div className="mb-12">
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//         {teachers.slice(0).filter((_, i) => i !== 0).map((teacher, index) => (
//           <div key={index} className="group bg-gray-950 rounded-xl p-5 border border-gray-700/60 hover:border-brand-beige/30 transition-all duration-300 hover:translate-y-[-2px] shadow-lg shadow-black/30">
//             <div className="flex items-start gap-4 mb-4">
//               <div className="relative">
//                 <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-gray-700 overflow-hidden border border-gray-600 group-hover:border-brand-beige/30 transition-colors">
//                   <img
//                     src={teacher.image}
//                     alt={teacher.name}
//                     className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
//                   />
//                 </div>
//                 {teacher.name.includes('Dr.') && (
//                   <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-brand-red rounded-full flex items-center justify-center border border-white shadow-md">
//                     <span className="text-white text-xs font-bold">D</span>
//                   </div>
//                 )}
//               </div>
//               <div className="flex-1">
//                 <h3 className="text-lg md:text-xl font-lora font-semibold text-brand-beige mb-1">{teacher.name}</h3>
//                 <p className="text-gray-400 font-manrope text-sm mb-3">{teacher.occupation}</p>
                
//                 {/* Quick Qualifications */}
//                 <div className="mb-3">
//                   <div className="flex items-center text-gray-400 mb-2">
//                     <FiBook className="w-3 h-3 mr-1" />
//                     <span className="text-xs font-semibold">Top Qualifications</span>
//                   </div>
//                   <div className="space-y-1.5">
//                     {teacher.qualifications.map((qual, qIndex) => (
//                       <div key={qIndex} className="flex items-start">
//                         <div className="w-1.5 h-1.5 bg-brand-beige rounded-full mt-1.5 mr-2 flex-shrink-0"></div>
//                         <span className="text-gray-400 text-xs">{qual}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
                
//                 {/* Quick Experience */}
//                 <div>
//                   <div className="flex items-center text-gray-400 mb-2">
//                     <FiBriefcase className="w-3 h-3 mr-1" />
//                     <span className="text-xs font-semibold">Experience</span>
//                   </div>
//                   <div className="space-y-1.5">
//                     {teacher.experience.map((exp, eIndex) => (
//                       <div key={eIndex} className="flex items-start">
//                         <div className="w-1.5 h-1.5 bg-blue-400 rounded-full mt-1.5 mr-2 flex-shrink-0"></div>
//                         <span className="text-gray-400 text-xs">{exp}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
            
//             {/* Stats */}
//             <div className="pt-4 border-t border-gray-700 mt-4">
//               <div className="flex items-center justify-between">
//                 <div className="flex items-center">
//                   <div className="flex items-center text-gray-400 mr-3">
//                     <FiAward className="w-3 h-3 mr-1" />
//                     <span className="text-xs">{teacher.qualifications.length} Quals</span>
//                   </div>
//                   <div className="flex items-center text-gray-400">
//                     <FiClock className="w-3 h-3 mr-1" />
//                     <span className="text-xs">{teacher.experience.length} Roles</span>
//                   </div>
//                 </div>
//                 {teacher.qualifications.some(q => q.includes('MBA')) && (
//                   <span className="px-2 py-0.5 bg-green-500/30 text-green-300 text-xs font-bold rounded">MBA</span>
//                 )}
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>



//   </div>
// </section>
//             <section className="w-full flex flex-col md:flex-row items-stretch">
//               {/* Left side: background image + gray overlay + text */}
//               <div
//                 className="w-full md:w-1/2 relative bg-gray-900  bg-center"
//                 // style={{
//                 //   backgroundImage: "url('./memories.webp')",
//                 // }}
//               >
//                 {/* Gray overlay */}
//                 <div className="absolute inset-0  bg-opacity-80"></div>

//                 {/* Text content */}
//                 <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
//                   <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
//                     Trust in Our Expertise
//                   </h2>
//                   <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
//                     Our teaching methodology is designed to build confidence,
//                     encourage critical thinking, and foster a love of learning.
//                     At BI, your success is our mission.
//                   </p>
//                 </div>
//               </div>

//               {/* Right side: just an image */}
//               <div className="w-full md:w-1/2">
//                 <img
//                   src="https://bic-bangkok.vercel.app/trust.jpg"
//                   alt="Trust Image"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//             </section>



// <section
//   ref={carouselRef}
//   className="w-full py-20 md:py-28 overflow-hidden"
//   style={{ background: "#080b12" }}
// >
//   {/* Header */}
//   <div className="text-center mb-14 px-6">
//     <div className="inline-block mb-4 px-4 py-1.5 bg-brand-red/20 rounded-full border border-brand-red/40">
//       <span className="text-brand-beige font-manrope font-semibold text-xs uppercase tracking-widest">
//         Student Success
//       </span>
//     </div>

//     <h2 className="text-4xl md:text-5xl lg:text-6xl font-lora font-semibold text-brand-beige mb-4">
//       Bridge <span className="text-brand-red">Hero</span> Success
//     </h2>

//     <div className="w-16 h-1 bg-brand-red mx-auto mb-4 rounded-full" />

//     <p className="text-gray-500 font-manrope text-sm md:text-base max-w-xl mx-auto leading-relaxed">
//       Our graduates are making their mark at world-class universities across
//       the globe.
//     </p>
//   </div>

//   {/* Carousel */}
//   <div className="overflow-hidden w-full">
//     <div
//       className="flex items-center transition-transform duration-[1000ms] ease-[cubic-bezier(.22,1,.36,1)]"
// style={{
//   transform: `translateX(calc(50vw - ${
//     (currentSlide + 0.5) * (window.innerWidth >= 1024 ? 30 : 80)
//   }vw))`,
// }}
//     >
//    {students.map((student, idx) => (
//   <div
//     key={student.name}
//     className="flex-shrink-0 w-[80vw] lg:w-[30vw] px-4 cursor-pointer"
//     onClick={() => setCurrentSlide(idx)}
//   >
//     <div
//       className="relative w-full aspect-[4/5] rounded-3xl overflow-hidden transition-all duration-700 hover:scale-[1.02]"
//       style={{
//         transform:
//           idx === currentSlide
//             ? "scale(1)"
//             : Math.abs(idx - currentSlide) === 1
//             ? "scale(0.94)"
//             : "scale(0.9)",

//         opacity:
//           idx === currentSlide
//             ? 1
//             : Math.abs(idx - currentSlide) === 1
//             ? 0.75
//             : 0.5,

//         boxShadow:
//           idx === currentSlide
//             ? "0 30px 80px rgba(185,28,28,.35)"
//             : "0 10px 40px rgba(0,0,0,.3)",
//       }}
//     >
//       <img
//         src={student.image}
//         alt={student.name}
//         className="absolute inset-0 w-full h-full object-cover object-top"
//         onError={(e) => {
//           e.target.style.display = "none";
//         }}
//       />

//       <div
//         className="absolute inset-0"
//         style={{
//           background: `
//             linear-gradient(
//               to bottom,
//               rgba(0,0,0,0) 10%,
//               rgba(0,0,0,.15) 35%,
//               rgba(0,0,0,.75) 70%,
//               rgba(0,0,0,.98) 100%
//             )
//           `,
//         }}
//       />

//       <div className="absolute bottom-0 left-0 right-0 z-10 p-6 md:p-10 lg:p-12">
//         <h3 className="font-lora font-semibold text-white text-3xl md:text-4xl lg:text-5xl mb-4">
//           {student.name}
//         </h3>

//         <div className="flex flex-wrap gap-2 mb-5">
//           <span className="bg-brand-red text-white text-xs md:text-sm font-manrope font-bold px-4 py-2 rounded-full">
//             {student.program}
//           </span>

//           <span className="bg-white/10 border border-white/20 text-white/80 text-xs md:text-sm font-manrope px-4 py-2 rounded-full">
//             Batch {student.batch}
//           </span>

//          {
//           student.pathway != "" &&  <span className="bg-brand-beige/20 border border-brand-beige/30 text-brand-beige text-xs md:text-sm font-manrope px-4 py-2 rounded-full">
//             {student.pathway}
//           </span>
//          }
//         </div>

//         <div className="flex flex-wrap gap-3">
//      {student.universities.map((uni) => (
//   <div
//     key={uni.name}
//     className="group relative w-16 h-16 overflow-hidden rounded-xl bg-white border border-gray-200 hover:border-brand-red/40 hover:shadow-lg hover:shadow-brand-red/10 hover:scale-105 transition-all duration-300"
//   >
//     <img
//       src={uni.logo}
//       alt={uni.name}
//       className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
//       onError={(e) => {
//         e.target.style.display = "none";
//         e.target.nextSibling.style.display = "flex";
//       }}
//     />

//     {/* Fallback */}
//     <div className="hidden absolute inset-0 items-center justify-center bg-white p-1">
//       <span className="text-[8px] text-center font-medium text-gray-700 leading-tight">
//         {uni.name}
//       </span>
//     </div>

//     {/* Hover Overlay */}
//     <div className="absolute inset-0 bg-brand-red/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//   </div>
// ))}
//         </div>
//       </div>
//     </div>
//   </div>
// ))}
//     </div>
//   </div>


// </section>

//             {/* Activities Section */}
//             <section className="py-16 md:py-24 bg-dark-blue relative overflow-hidden">
//               <div className="absolute inset-0">
//                 <div className="absolute top-20 left-10 w-32 h-32 bg-brand-red/10 rounded-full blur-3xl"></div>
//                 <div className="absolute bottom-20 right-10 w-40 h-40 bg-brand-beige/10 rounded-full blur-3xl"></div>
//                 <div className="absolute top-1/2 left-1/4 w-2 h-20 bg-brand-red/20 rotate-45 rounded-full"></div>
//                 <div className="absolute bottom-1/3 right-1/3 w-16 h-2 bg-brand-beige/20 rounded-full"></div>
//               </div>

//               <div className="container mx-auto px-4 relative z-10">
            

//                 <div className="mt-12 md:mt-16">
//                   <div className="text-center mb-8">
//                     <h3 className="text-2xl md:text-3xl font-lora font-semibold text-white mb-2">
//                       Discover the BI{" "}
//                       <span className="text-brand-red">Experience</span>
//                     </h3>
//                     <p className="text-gray-400 text-sm md:text-base">
//                       Explore our world-class facilities and vibrant spaces, 
//                       <span className="text-brand-red font-medium">
//                        designed to inspire your academic and personal journey.
//                       </span>{" "}
                   
//                     </p>
//                   </div>



// {/* <div className="mt-12 md:mt-16">
//   <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8 md:mb-10">
//     {["All", "Campus Grounds", "Library & Study Spaces", "Sports Facilities", "Modern Classrooms", "Canteen & Dining", "Boarding Facilities"].map((category) => {
//       const categoryKey = category === "All" ? "all" : 
//         category === "Campus Grounds" ? "campus" :
//         category === "Library & Study Spaces" ? "library" :
//         category === "Sports Facilities" ? "sports" :
//         category === "Modern Classrooms" ? "classrooms" :
//         category === "Canteen & Dining" ? "canteen" : "boarding";
      
//       return (
//         <button
//           key={category}
//           onClick={() => setActiveCategory(categoryKey)}
//           className={`px-4 md:px-6 py-2 md:py-2.5 rounded-full text-sm md:text-base font-manrope font-medium transition-all duration-300 ${
//             activeCategory === categoryKey
//               ? "bg-brand-red text-white shadow-lg shadow-brand-red/30"
//               : "bg-gray-800/60 text-gray-300 hover:bg-gray-700/60 hover:text-white border border-gray-700"
//           }`}
//         >
//           {category}
//         </button>
//       );
//     })}
//   </div>

//   <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4 max-w-7xl mx-auto">
//     {(() => {
//       const allImages = [
//         { src: "campus/campus1.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "campus/campus2.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "campus/campus3.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "campus/campus4.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "campus/campus5.jpg", category: "campus", label: "Campus Grounds" },
//             { src: "campus/campus6.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "campus/campus7.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "campus/campus8.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "library1.jpg", category: "library", label: "Library & Study Spaces" },
//         { src: "library/library2.jpg", category: "library", label: "Library & Study Spaces" },
//         { src: "library3.jpg", category: "library", label: "Library & Study Spaces" },
//         {src: "library/library4.jpg", category: "library", "label":"Library & Study Spaces"},
//           { src: "library/library5.jpg", category: "library", label: "Library & Study Spaces" },
//         { src: "library/library6.jpg", category: "library", label: "Library & Study Spaces" },
//         { src: "library/library7.jpg", category: "library", label: "Library & Study Spaces" },
//         {src: "library/library8.jpg", category: "library", "label":"Library & Study Spaces"},
//         { src: "sports/sports1.jpg", category: "sports", label: "Sports Facilities" },
//         { src: "sports/sports2.jpg", category: "sports", label: "Sports Facilities" },
//         { src: "sports/sports3.jpg", category: "sports", label: "Sports Facilities" },
//        { src: "sports/sports4.jpg", category: "sports", label: "Sports Facilities" },
//         { src: "sports/sports5.jpg", category: "sports", label: "Sports Facilities" },
//          { src: "sports/sports6.jpg", category: "sports", label: "Sports Facilities" },
//         { src: "class/classroom1.jpg", category: "classrooms", label: "Modern Classrooms" },
//         { src: "class/classroom2.jpg", category: "classrooms", label: "Modern Classrooms" },
//         { src: "class/classroom3.jpg", category: "classrooms", label: "Modern Classrooms" },
//          { src: "class/classroom4.jpg", category: "classrooms", label: "Modern Classrooms" },
//         { src: "canteen/canteen1.jpg", category: "canteen", label: "Canteen & Dining" },
//         { src: "canteen/canteen2.jpg", category: "canteen", label: "Canteen & Dining" },
//         { src: "canteen/canteen3.jpg", category: "canteen", label: "Canteen & Dining" },
//         { src: "canteen/canteen4.jpg", category: "canteen", label: "Canteen & Dining" },
//         { src: "canteen/canteen5.jpg", category: "canteen", label: "Canteen & Dining" },
//         { src: "boarding/boarding1.jpg", category: "boarding", label: "Boarding Facilities" },
//         { src: "boarding/boarding2.jpg", category: "boarding", label: "Boarding Facilities" },
//         { src: "boarding/boarding3.jpg", category: "boarding", label: "Boarding Facilities" },
//          { src: "boarding/boarding4.jpg", category: "boarding", label: "Boarding Facilities" },
//           { src: "boarding/boarding5.jpg", category: "boarding", label: "Boarding Facilities" },
//       ];

//       const filteredImages = activeCategory === "all" 
//         ? allImages 
//         : allImages.filter(img => img.category === activeCategory);

//       return filteredImages.map((image, index) => (
//         <div
//           key={index}
//           className="group relative aspect-square overflow-hidden rounded-xl bg-gray-800/50 border border-white/10 hover:border-brand-beige/50 transition-all duration-500 cursor-pointer"
//           onClick={() => {
//             console.log(`Clicked: ${image.src}`);
//           }}
//         >
//           <img
//             src={`https://bic-bangkok.vercel.app/${image.src}`}
//             alt={image.label}
//             className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//             onError={(e) => {
//               e.target.src = "https://bic-bangkok.vercel.app/placeholder.jpg";
//             }}
//           />
//           <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//           <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 opacity-0 group-hover:opacity-100">
//             <p className="text-white text-xs md:text-sm font-manrope font-medium truncate">
//               {image.label}
//             </p>
//           </div>
//         </div>
//       ));
//     })()}
//   </div>

// <br /><br />
// </div> */}


// {/* Categorized Image Gallery Section */}
// <div className="mt-12 mb-12 md:mt-16">
//   <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8 md:mb-10">
//     {["All", "Campus Grounds", "Library & Study Spaces", "Sports Facilities", "Modern Classrooms", "Canteen & Dining", "Boarding Facilities"].map((category) => {
//       const categoryKey = category === "All" ? "all" : 
//         category === "Campus Grounds" ? "campus" :
//         category === "Library & Study Spaces" ? "library" :
//         category === "Sports Facilities" ? "sports" :
//         category === "Modern Classrooms" ? "classrooms" :
//         category === "Canteen & Dining" ? "canteen" : "boarding";
      
//       return (
//         <button
//           key={category}
//           onClick={() => setActiveCategory(categoryKey)}
//           className={`px-4 md:px-6 py-2 md:py-2.5 rounded-full text-sm md:text-base font-manrope font-medium transition-all duration-300 ${
//             activeCategory === categoryKey
//               ? "bg-brand-red text-white shadow-lg shadow-brand-red/30"
//               : "bg-gray-800/60 text-gray-300 hover:bg-gray-700/60 hover:text-white border border-gray-700"
//           }`}
//         >
//           {category}
//         </button>
//       );
//     })}
//   </div>

//   <div className="max-w-7xl mx-auto">
//     {(() => {
//       const allImages = [
//         { src: "campus/campus1.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "campus/campus2.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "campus/campus3.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "campus/campus4.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "campus/campus5.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "campus/campus6.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "campus/campus7.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "campus/campus8.jpg", category: "campus", label: "Campus Grounds" },
//         { src: "library1.jpg", category: "library", label: "Library & Study Spaces" },
//         { src: "library/library2.jpg", category: "library", label: "Library & Study Spaces" },
//         { src: "library3.jpg", category: "library", label: "Library & Study Spaces" },
//         { src: "library/library4.jpg", category: "library", label: "Library & Study Spaces" },
//         { src: "library/library5.jpg", category: "library", label: "Library & Study Spaces" },
//         { src: "library/library6.jpg", category: "library", label: "Library & Study Spaces" },
//         { src: "library/library7.jpg", category: "library", label: "Library & Study Spaces" },
//         { src: "library/library8.jpg", category: "library", label: "Library & Study Spaces" },
//         { src: "sports/sports1.jpg", category: "sports", label: "Sports Facilities" },
//         { src: "sports/sports2.jpg", category: "sports", label: "Sports Facilities" },
//         { src: "sports/sports3.jpg", category: "sports", label: "Sports Facilities" },
//         { src: "sports/sports4.jpg", category: "sports", label: "Sports Facilities" },
//         { src: "sports/sports5.jpg", category: "sports", label: "Sports Facilities" },
//         { src: "sports/sports6.jpg", category: "sports", label: "Sports Facilities" },
//         { src: "class/classroom1.jpg", category: "classrooms", label: "Modern Classrooms" },
//         { src: "class/classroom2.jpg", category: "classrooms", label: "Modern Classrooms" },
//         { src: "class/classroom3.jpg", category: "classrooms", label: "Modern Classrooms" },
//         { src: "class/classroom4.jpg", category: "classrooms", label: "Modern Classrooms" },
//         { src: "canteen/canteen1.jpg", category: "canteen", label: "Canteen & Dining" },
//         { src: "canteen/canteen2.jpg", category: "canteen", label: "Canteen & Dining" },
//         { src: "canteen/canteen3.jpg", category: "canteen", label: "Canteen & Dining" },
//         { src: "canteen/canteen4.jpg", category: "canteen", label: "Canteen & Dining" },
//         { src: "canteen/canteen5.jpg", category: "canteen", label: "Canteen & Dining" },
//         { src: "boarding/boarding1.jpg", category: "boarding", label: "Boarding Facilities" },
//         { src: "boarding/boarding2.jpg", category: "boarding", label: "Boarding Facilities" },
//         { src: "boarding/boarding3.jpg", category: "boarding", label: "Boarding Facilities" },
//         { src: "boarding/boarding4.jpg", category: "boarding", label: "Boarding Facilities" },
//         { src: "boarding/boarding5.jpg", category: "boarding", label: "Boarding Facilities" },
//       ];

//       const filteredImages = activeCategory === "all" 
//         ? allImages 
//         : allImages.filter(img => img.category === activeCategory);

//       const imageCount = filteredImages.length;

//       // Determine grid columns based on count
//       let gridCols = "grid-cols-2 sm:grid-cols-3 md:grid-cols-4";
      
//       if (imageCount <= 2) {
//         gridCols = "grid-cols-1 sm:grid-cols-2";
//       } else if (imageCount <= 4) {
//         gridCols = "grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4";
//       } else if (imageCount <= 6) {
//         gridCols = "grid-cols-2 sm:grid-cols-2 md:grid-cols-3";
//       } else if (imageCount <= 8) {
//         gridCols = "grid-cols-2 sm:grid-cols-3 md:grid-cols-4";
//       } else {
//         gridCols = "grid-cols-2 sm:grid-cols-3 md:grid-cols-4";
//       }

//       // If no images, show a message
//       if (imageCount === 0) {
//         return (
//           <div className="text-center py-12">
//             <p className="text-gray-400 font-manrope">No images available for this category</p>
//           </div>
//         );
//       }

//       return (
//         <div className={`grid ${gridCols} gap-3 md:gap-4`}>
//           {filteredImages.map((image, index) => (
//             <div
//               key={index}
//               className="group relative aspect-square overflow-hidden rounded-xl bg-gray-800/50 border border-white/10 hover:border-brand-beige/50 transition-all duration-500 cursor-pointer"
//               onClick={() => {
//                 console.log(`Clicked: ${image.src}`);
//               }}
//             >
//               <img
//                 src={`https://bic-bangkok.vercel.app/${image.src}`}
//                 alt={image.label}
//                 className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//                 onError={(e) => {
//                   e.target.src = "https://bic-bangkok.vercel.app/placeholder.jpg";
//                 }}
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//               <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 opacity-0 group-hover:opacity-100">
//                 <p className="text-white text-xs md:text-sm font-manrope font-medium truncate">
//                   {image.label}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       );
//     })()}
//   </div>
// </div>
              
              
//                   <div className="grid md:grid-cols-2 gap-8 md:gap-12 max-w-7xl mx-auto">
//                     {videos?.map((video) => (
//                       <div key={video.id} className="group relative">
//                         <div className="relative">
//                           {/* Video iframe */}
//                           <div className="relative aspect-video rounded-3xl overflow-hidden bg-gradient-to-br from-gray-800/80 to-gray-900/80 border-2 border-white/10 hover:border-brand-red/60 transition-all duration-700 shadow-2xl hover:shadow-brand-red/20">
//                             <iframe
//                               src={`https://www.youtube.com/embed/${video.embed_id}`}
//                               title={video.title}
//                               className="w-full h-full"
//                               frameBorder="0"
//                               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                               allowFullScreen
//                             ></iframe>
//                             <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent pointer-events-none"></div>
//                             <div className="absolute top-4 right-4 w-3 h-3 bg-brand-red rounded-full opacity-80 animate-pulse"></div>
//                           </div>

//                           {/* Video description */}
//                           <div className="mt-6 text-center">
//                             <h4 className="text-xl md:text-2xl font-lora font-bold text-white mb-3 group-hover:text-brand-red transition-colors duration-300">
//                               {video.title}
//                             </h4>
//                             <p className="text-gray-400 text-sm md:text-base leading-relaxed max-w-sm mx-auto">
//                               {video.description}
//                             </p>
//                             <p className="text-gray-500 text-xs mt-2">
//                               Uploaded:{" "}
//                               {new Date(video.created_at).toLocaleDateString()}
//                             </p>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Activity Gallery - keeping existing design */}
//                 <div className="mt-16 md:mt-20">
//                   <div className="text-center mb-12">
//                     <h3 className="text-3xl md:text-4xl font-lora font-bold text-brand-red mb-4">
//                       Activity Galleries
//                     </h3>
//                     <p className="text-lg text-gray-300 max-w-2xl mx-auto">
//                       Explore the vibrant moments that showcase our dynamic
//                       student community and diverse campus experiences
//                     </p>
//                   </div>

//                   {/* Photo Grid */}
//                   {galleries.length == 0 && (
//                     <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
//                       {[1, 2, 3, 4, 5, 6].map((num) => (
//                         <div
//                           key={num}
//                           className="group relative aspect-square overflow-hidden rounded-2xl bg-gray-800/50 border border-white/10 hover:border-brand-beige/50 transition-all duration-500"
//                         >
//                           <img
//                             src={`https://bic-bangkok.vercel.app/act${num}.jpg`}
//                             alt={`Student Activity ${num}`}
//                             className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//                           />
//                           <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//                           <div className="absolute bottom-4 left-4 right-4 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 opacity-0 group-hover:opacity-100">
//                             <div className="text-white">
//                               <div className="w-8 h-8 bg-brand-red rounded-full flex items-center justify-center mb-2">
//                                 <div className="w-4 h-4 bg-white rounded-full"></div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                   {galleries.length != 0 && (
//                     <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
//                       {galleries.map((item) => (
//                         <div
//                           key={item.id}
//                           className="group relative aspect-square overflow-hidden rounded-2xl bg-gray-800/50 border border-white/10 hover:border-brand-beige/50 transition-all duration-500"
//                         >
//                           <img
//                             src={`${new_backend_domain_name}/public/storage/${item.gallery}`}
//                             alt={`Gallery ${item.id}`}
//                             className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//                           />
//                           <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//                           <div className="absolute bottom-4 left-4 right-4 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 opacity-0 group-hover:opacity-100">
//                             <div className="text-white">
//                               <div className="w-8 h-8 bg-brand-red rounded-full flex items-center justify-center mb-2">
//                                 <div className="w-4 h-4 bg-white rounded-full"></div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </section>




//             <section className="w-screen relative">
//               {/* Full background image */}
//               <img
//                 src="https://bic-bangkok.vercel.app/replace.jpg"
//                 alt="Trust us to guide your academic journey"
//                 className="w-screen h-[60vh] md:h-auto object-cover"
//               />

//               {/* Dark overlay */}
//               <div className="absolute inset-0 bg-black/60"></div>

//               {/* Text content */}
//               <div className="absolute inset-0 flex items-center justify-center px-4 sm:px-6">
//                 <div className="text-center max-w-3xl space-y-4 sm:space-y-6 md:space-y-8 z-10">
//                   <h2 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-lora font-extrabold text-gray-200 leading-snug drop-shadow-lg">
//                     Trust Us to Guide Your Academic Journey
//                   </h2>
//                   <p className="text-base sm:text-lg md:text-2xl font-manrope font-semibold text-brand-beige leading-relaxed drop-shadow-md">
//                     Join a community where your success is our priority. We
//                     offer personalized learning, state-of-the-art facilities,
//                     and a supportive environment that nurtures every student's
//                     potential.
//                   </p>

//                   <Link
//                     to="/enquire"
//                     className="inline-block bg-brand-red hover:bg-red-700 text-white font-manrope font-bold text-base sm:text-lg md:text-xl px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 shadow-lg transition-all hover:scale-105 rounded-lg sm:rounded-xl"
//                   >
//                     Apply Now
//                   </Link>
//                 </div>
//               </div>
//             </section>

//             <div className="relative z-10"></div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }


"use client";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import Banner from "../components/banner";
import Navigation from "../components/navigation";
import { FiArrowRight, FiAward, FiBook, FiBriefcase, FiChevronLeft, FiChevronRight, FiClock, FiGlobe, FiMic, FiStar, FiUsers } from "react-icons/fi";
import { FaGlobeAsia } from "react-icons/fa";
// import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  setStoreReduxGallery,
  setStoreReduxText,
  setStoreReduxVideo,
} from "../../reducer/gallerySlice";

const homeImages = [
  "./1.jpg",
  "./2.jpg",
  "./3.jpg",
  "./4.jpg",
  "./5.jpg",
  "./6.jpg",
  "./7.jpg",
  "./8.jpg",
];

function PlayIcon({ className }) {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
      />
    </svg>
  );
}

function SkeletonBox({ className }) {
  return (
    <div
      className={`bg-gray-700/50 animate-pulse rounded-lg ${className}`}
    ></div>
  );
}

function SkeletonText({ className }) {
  return (
    <div className={`bg-gray-600/50 animate-pulse rounded ${className}`}></div>
  );
}

export default function HomePage() {
  // const backend_domain_name = `https://bicadmin.z256600-ll9lz.ps02.zwhhosting.com`;
  const new_backend_domain_name = `https://bi.oasisyangonmm.com`
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeLifeSection, setActiveLifeSection] = useState(0);
  const [activeCategory, setActiveCategory] = useState("all");
  // const ReduxGallerySection = useSelector((store) => store.galleries);
  const [galleries, setGalleries] = useState([]);
  const [videos, setVideos] = useState([]);
  const [galleryText, setGalleryText] = useState([]);
 const [isCarouselVisible, setIsCarouselVisible] = useState(false);
const carouselRef = useRef(null);

  const sectionRefs = useRef([]);
  const teachers = [
  {
    name: "Mr. Iqbal",
    occupation: "Biology Teacher",
    image: "https://bic-bangkok.vercel.app/teachers/Mr.%20Iqbal.jpg",
    qualifications: [
      "MSc Modelling for Global Health - University of Oxford",
      "BSc Human Genetics - University College London"
      
    ],
    experience: [
      
      "3+ Years of teaching experience in Biology and Chemistry",
      "A-Level Foundation, NCUK, and OSSD programs"
    ]
  },
  {
    name: "Ms. Hkwan Ra",
    occupation: "Business, Economic and Accounting Teacher",
    image: "https://bic-bangkok.vercel.app/teachers/Ms.%20Hkwan%20Ra.jpg",
    qualifications: [
      "Dip in International Business Law (ACTD, USA)",
      "MBA (IES, France) | M.Ed (IBES, France)",
      "ACCA Part 2 (UK) | B.Com (MUE, Myanmar)"
    ],
    experience: [
      "10+ Years of teaching experiences in Businesses, Economic and Accounting",
      "2 years in IBDP and 8 years in A-Levels"
    ]
  },

  {
    name: "Mr. Roland",
    occupation: "Physics Teacher",
    image: "https://bic-bangkok.vercel.app/teachers/Mr.%20Roland.jpg",
    qualifications: [
      "PhD Thesis (Physics) - University of Yangon",
      "MSc Physics - Yandanabon University",
      "BSc (Honours) Physics - Bago University"
    ],
    experience: [
      "15+ Years of teaching experience in Physics"
    ]
  },
  {
    name: "Dr. Khine Min Min Oo",
    occupation: "Mathematics Teacher",
    image: "https://bic-bangkok.vercel.app/teachers/Dr.%20Khine%20Min%20Min%20Oo.jpg",
    qualifications: [
      "PhD - Zhejiang Normal University, China",
      "MSc & BSc - Taunggyi University"
    ],
    experience: [
      "Over 13 years of teaching experience"
    ]
  },
   {
    name: "Mr. Steven",
    occupation: "Business Teacher",
    image: "https://bic-bangkok.vercel.app/teachers/Mr.%20Steven.jpg",
    qualifications: [
      "Double Top Paper Prize Awardee (ABE, UK) ",
      "MSc in Marketing - Leeds Business School (UK)",
      "MBA - University of Northampton (UK)",
      "Level 6 Graduate Diploma in Business Management (ABE, UK)",
      "Double Top Paper Prize Awardee (ABE, UK)"
    ],
    experience: [
      "4+ Years of teaching Business subjects in private universities"
    ]
  },
  {
    name: "Mr. Si Thu Nyein",
    occupation: "Business Teacher",
    image: "https://bic-bangkok.vercel.app/teachers/Mr.%20Si%20Thu%20Nyein.jpg",
    qualifications: [
      "BSc (Hons) Mechanical Engineering - Coventry University (UK)"
    ],
    experience: [
      "Over 5 years of teaching experience (GED)"
    ]
  },
  {
    name: "Mr. Pyae Sone Tun",
    occupation: "Business Teacher",
    image: "https://bic-bangkok.vercel.app/teachers/Mr.Pyae%20Sone%20Tun.png",
    qualifications: [
      "Bachelor of Electrical and Electronics Engineering (Hons) - University of East London",
      "Level 7 of Educational Management and Leadership (Ongoing)"
    ],
    experience: [
      "6+ years of teaching experience in IGCSE O-Level and GED (Mathematics)",
      "4+ years of teaching experience in University Entrance Exams",
      "1+ year of teaching experience in Thailand"
    ]
  },
    {
    name: "Ms. Béibhinn Ní Dhonnchadha",
    occupation: "English Teacher",
    image: "https://bic-bangkok.vercel.app/teachers/Beibhinn.jpg",
    qualifications: [
      "BA (Mod.) Neuroscience (2013-2017) - Trinity College Dublin",
      "MSc Clinical and Translational Research (2018-2019) - University College Dublin",
      "CELTA (Apr 2025) - International House Bangkok"
    ],
    experience: [
      "May 2025 - Sep 2025: English Teacher at International House Bangkok",
      "Sep 2025 - Present: English Teacher at Hysan Education"
    ]
  },
  {
    name: "Ms. Anila Riaz",
    occupation: "Biochemistry and Chemistry Teacher",
    image: "https://bic-bangkok.vercel.app/teachers/Anila.jpg",
    qualifications: [
      "PhD Biochemistry (in progress) - Chulalongkorn University, Bangkok, Thailand",
      "Masters in Chemistry - Islamia College Peshawar, Pakistan",
      "Bachelor in Chemistry - University of Peshawar, Pakistan"
    ],
    experience: []
  }


];


  const lifeSections = [
    {
      title: "Cultural Immersion",
      description:
        "Immerse yourself in Thai culture while maintaining your global perspective. Our students experience the rich traditions, festivals, and customs of Thailand through organized cultural activities and community engagement.",
      image: "https://bic-bangkok.vercel.app/cultural.webp",
      details: [
        "Traditional Thai festivals and celebrations",
        "Cultural exchange programs with local communities",
        "Language immersion opportunities",
        "Historical site visits and cultural tours",
      ],
    },
    {
      title: "Extracurricular Activities",
      description:
        "From sports teams to academic clubs, drama productions to community service projects. Our diverse range of activities ensures every student finds their passion and develops leadership skills.",
      image: "https://bic-bangkok.vercel.app/extra.webp",
      details: [
        "Sports teams and fitness programs",
        "Academic clubs and competitions",
        "Drama and arts productions",
        "Community service initiatives",
      ],
    },
    {
      title: "Build Lifelong Memories",
      description:
        "Create unforgettable experiences with classmates from around the world. Our campus events, international trips, and graduation celebrations become cherished memories that last a lifetime.",
      image: "https://bic-bangkok.vercel.app/memories.webp",
      details: [
        "International student exchange programs",
        "Campus events and celebrations",
        "Graduation ceremonies and achievements",
        "Alumni network connections",
      ],
    },
    {
      title: "Accommodation",
      description:
        "We offer a variety of safe and modern living options, including on-campus residences and off-campus housing with trusted partners. All accommodations are equipped with the amenities needed to create a comfortable and productive living environment.",
      image: "https://bic-bangkok.vercel.app/accomodation.webp",
      details: [
        "On-campus residences with 24/7 security",
        "Off-campus housing with trusted partners",
        "Modern amenities and comfortable furnishings",
        "Study spaces and recreational facilities",
      ],
    },
  ];
const [isTransitioning, setIsTransitioning] = useState(true);

//   const students = [
//   {
//     name: "Swan Htet Nay Khaing",
//     program: "A-Level",
//     batch: "1",
//     image: "swan-htet.jpg", // Replace with actual image URL
//     universities: [
//       { name: "University of Cambridge", logo: "https://your-image-host.com/cambridge-logo.png" },
//       { name: "University of Toronto", logo: "https://your-image-host.com/toronto-logo.png" }
//     ]
//   },
//   {
//     name: "May Thway Ko",
//     program: "OSSD",
//     batch: "1",
//     image: "maythweko.jpg", // Replace with actual image URL
//     universities: [
//       { name: "Zhejiang Medical University", logo: "https://your-image-host.com/zhejiang-logo.png" }
//     ]
//   },
//   {
//     name: "Yati Su Lwin",
//     program: "OSSD",
//     batch: "1",
//     image: "yati.jpg", // Replace with actual image URL
//     universities: [
//       { name: "Queen's University", logo: "https://your-image-host.com/queens-logo.png" },
//       { name: "Western University", logo: "https://your-image-host.com/western-logo.png" },
//       { name: "University of Guelph", logo: "https://your-image-host.com/guelph-logo.png" },
//       { name: "Carleton University", logo: "https://your-image-host.com/carleton-logo.png" }
//     ]
//   },
//   {
//     name: "Min Khant Thaw",
//     program: "OSSD",
//     batch: "2",
//     image: "minkhant.jpg", // Replace with actual image URL
//     universities: [
//       { name: "Seneca Polytechnic", logo: "https://your-image-host.com/seneca-logo.png" }
//     ]
//   },
//   {
//     name: "Kaung Set Lin",
//     program: "OSSD",
//     batch: "2",
//     image: "kaungset.jpg", // Replace with actual image URL
//     universities: [
//       { name: "City St George's University of London", logo: "https://your-image-host.com/city-london-logo.png" },
//       { name: "Brunel University London", logo: "https://your-image-host.com/brunel-logo.png" },
//       { name: "Kingston University London", logo: "https://your-image-host.com/kingston-logo.png" },
//       { name: "Middlesex University London", logo: "https://your-image-host.com/middlesex-logo.png" }
//     ]
//   }
// ];

const students = [
  {
    name: "Swan Htet Nay Khaing",
    program: "A-Level",
    batch: "1",
    pathway: "",
    image: "swan-htet.jpg",
    universities: [
      { name: "University of Cambridge", logo: "cambridge.jpg" },
      { name: "University of Toronto", logo: "toronto.webp" }
    ]
  },
  {
    name: "May Thway Ko",
    program: "OSSD",
    batch: "1",
    pathway: "Medical Pathway",
    image: "maythweko.jpg",
    universities: [
      { name: "Zhejiang Medical University", logo: "zhejiang.webp" }
    ]
  },
  {
    name: "Yati Su Lwin",
    program: "OSSD",
    batch: "1",
    pathway: "Engineering Pathway",
    image: "yati.jpg",
    universities: [
      { name: "Queen's University", logo: "queen.webp" },
      { name: "Western University", logo: "western.webp" },
      { name: "University of Guelph", logo: "guelph.webp" },
      { name: "Carleton University", logo: "carleton.webp" }
    ]
  },
  {
    name: "Min Khant Thaw",
    program: "OSSD",
    batch: "2",
    pathway: "Computer Science Pathway",
    image: "minkhant.jpg",
    universities: [
      { name: "Seneca Polytechnic", logo: "seneca.png" }
    ]
  },
  {
    name: "Kaung Set Lin",
    program: "OSSD",
    batch: "2",
    pathway: "Business Pathway",
    image: "kaungset.jpg",
    universities: [
      { name: "City St George's University of London", logo: "george.jpg" },
      { name: "Brunel University London", logo: "brunei.jpg" },
      { name: "Kingston University London", logo: "kingston.jpg" },
      { name: "Middlesex University London", logo: "middlesex.webp" }
    ]
  },
  {
    name: "Min Hein Khant",
    program: "OSSD",
    batch: "2",
    pathway: "Medical Pathway",
    image: "minheinkhant.jpg",
    universities: [
      { name: "University of Parma", logo: "parma.png" }
    ]
  },
  {
    name: "Chit Su Naing",
    program: "OSSD",
    batch: "2",
    pathway: "Computer Science Pathway",
    image: "chitsunaing.jpg",
    universities: [
      { name: "University of Sheffield", logo: "sheffield.png" },
      { name: "University of Southampton", logo: "southampton.png" },
      { name: "Fraser International College", logo: "fraser.png" }
    ]
  }
];
const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${new_backend_domain_name}/api/galleries`);
      if (response.status == 200) {
        console.log(response.data);
        setGalleryText(response.data.data.text);
        setVideos(response.data.data.video);
        setGalleries(response.data.data.galleries);
        console.log(response.data.data.text);
        // dispatch(setReduxMainSponsors(response.data.mainSponsors));
        // dispatch(setReduxDiamondSponsors(response.data.diamondSponsors));
        // dispatch(setReduxPrevSponsors(response.data.prevSponsors));
        // dispatch(setStoreReduxFaq(response.data.faqs));
      } else {
        console.log("error");
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error in fetchApi:", error);
      setIsLoading(false);
    }
  };
useEffect(() => {
  let interval;

  // Start immediately
  interval = setInterval(() => {
    // Only advance if the section is visible
    if (isCarouselVisible) {
      setCurrentSlide((prev) => (prev + 1) % students.length);
    }
  }, 5000);

  return () => {
    if (interval) {
      clearInterval(interval);
    }
  };
}, [isCarouselVisible, students.length]);

  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0);

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 8000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
  if (isLoading) return;

  const currentElement = carouselRef.current;
  if (!currentElement) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        setIsCarouselVisible(entry.isIntersecting);
      });
    },
    {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    }
  );

  observer.observe(currentElement);

  return () => {
    observer.unobserve(currentElement);
  };
}, [isLoading]);

  return (
    <div
      className="relative min-h-screen font-lora"
      style={{
        overflowX: "hidden",
        maxWidth: "100vw",
        width: "100%",
      }}
    >
      <Navigation />

      <Banner
        title="Welcome to Bridge International  Bangkok"
        subtitle="Discover an unparalleled educational experience in the heart of Bangkok."
      />

      <div style={{ paddingTop: "10px" }}>
        {isLoading ? (
          <div className="space-y-0">
            <section className="w-full flex flex-col md:flex-row items-stretch">
              <div className="w-full md:w-1/2">
                <SkeletonBox className="w-full h-96 md:h-[500px]" />
              </div>
              <div className="w-full md:w-1/2 bg-dark-blue p-6 md:p-10 flex flex-col justify-center space-y-4">
                <SkeletonText className="h-10 w-3/4" />
                <SkeletonText className="h-4 w-full" />
                <SkeletonText className="h-4 w-5/6" />
                <SkeletonText className="h-4 w-4/5" />
                <div className="flex gap-4 pt-6">
                  <SkeletonBox className="h-12 w-32" />
                  <SkeletonBox className="h-12 w-32" />
                </div>
              </div>
            </section>

            <section className="w-full bg-grey-blue flex flex-wrap">
              {[1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className="w-1/2 md:w-1/4 p-4 flex justify-center items-center"
                >
                  <SkeletonBox className="h-20 w-32" />
                </div>
              ))}
            </section>

            {[1, 2, 3].map((i) => (
              <section
                key={i}
                className={`w-full flex flex-col ${
                  i % 2 === 0 ? "md:flex-row-reverse" : "md:flex-row"
                } items-stretch`}
              >
                <div className="w-full md:w-1/2">
                  <SkeletonBox className="w-full h-96 md:h-[400px]" />
                </div>
                <div className="w-full md:w-1/2 bg-dark-blue p-6 md:p-10 flex flex-col justify-center space-y-4">
                  <SkeletonText className="h-8 w-2/3" />
                  <SkeletonText className="h-4 w-full" />
                  <SkeletonText className="h-4 w-5/6" />
                  <SkeletonText className="h-4 w-3/4" />
                  <SkeletonBox className="h-12 w-36 mt-6" />
                </div>
              </section>
            ))}

            <section className="w-full flex flex-col md:flex-row items-start py-8 md:py-14 px-4 md:px-6 gap-8 md:gap-12 bg-dark-blue">
              <div className="w-full md:w-1/2 flex flex-col space-y-6">
                <SkeletonText className="h-12 w-3/4" />
                <SkeletonText className="h-6 w-1/2" />
                <SkeletonText className="h-4 w-full" />
                <SkeletonText className="h-4 w-5/6" />
                <SkeletonBox className="h-12 w-48 mt-6" />
              </div>
              <div className="w-full md:w-1/2 flex flex-col gap-3">
                <SkeletonBox className="aspect-video w-full rounded-xl" />
                <div className="grid grid-cols-3 gap-3">
                  {[1, 2, 3].map((i) => (
                    <SkeletonBox key={i} className="aspect-video rounded-lg" />
                  ))}
                </div>
              </div>
            </section>

            <section className="w-full py-12 md:py-20 px-4 md:px-6 bg-gradient-to-br from-dark-blue via-dark-primary to-dark-blue">
              <div className="max-w-7xl mx-auto">
                <div className="text-center mb-12">
                  <SkeletonText className="h-12 w-1/2 mx-auto mb-4" />
                  <SkeletonText className="h-6 w-3/4 mx-auto" />
                </div>
                <div className="space-y-16">
                  {[1, 2, 3].map((i) => (
                    <div
                      key={i}
                      className={`flex flex-col ${
                        i % 2 === 0 ? "lg:flex-row-reverse" : "lg:flex-row"
                      } gap-8 lg:gap-12 items-center`}
                    >
                      <div className="w-full lg:w-1/2">
                        <SkeletonBox className="aspect-video w-full rounded-2xl mb-4" />
                        <SkeletonBox className="aspect-video w-full rounded-xl" />
                      </div>
                      <div className="w-full lg:w-1/2 space-y-6">
                        <div className="flex items-center gap-3">
                          <SkeletonBox className="h-6 w-20" />
                          <SkeletonText className="h-8 w-1/2" />
                        </div>
                        <SkeletonText className="h-6 w-full" />
                        <SkeletonText className="h-4 w-5/6" />
                        <SkeletonText className="h-4 w-4/5" />
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 pt-4">
                          {[1, 2, 3, 4].map((j) => (
                            <SkeletonBox
                              key={j}
                              className="aspect-square rounded-xl"
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </div>
        ) : (
          <div className="space-y-0">
            <section className="w-full flex flex-col md:flex-row items-stretch">
              {/* Left side: just an image */}
              <div className="w-full md:w-1/2">
                <img
                  src="https://bic-bangkok.vercel.app/signage.jpg"
                  alt="Bridge International Bangkok"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Right side: background image + overlay + text */}
              <div
                className="w-full md:w-1/2 relative bg-cover bg-center"
                style={{
                  backgroundImage: "url('./bridge-bg.jpg')",
                }}
              >
                {/* Darker overlay */}
                <div className="absolute inset-0 bg-dark-blue bg-opacity-80"></div>

                {/* Text content */}
                <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
                  <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
                    What is Bridge International?
                  </h2>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    Bridge International (BI) is a premier educational
                    institution in Bangkok, dedicated to guiding ambitious
                    students toward top universities around the world.
                  </p>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    We serve as a bridge between potential and opportunity,
                    helping students gain the academic foundation, skills, and
                    confidence needed for admission into leading universities in
                    the UK, the United States, Australia, New Zealand, Canada,
                    Europe, and beyond.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-3 md:gap-4 pt-4">
                    <Link
                      to="/about"
                      className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold text-center rounded-lg shadow-md transition hover-lift font-manrope text-sm md:text-base"
                    >
                      Learn More
                    </Link>
                    <Link
                      to="/admissions"
                      className="px-4 md:px-6 py-2 md:py-3 bg-transparent border border-brand-beige text-center hover:bg-brand-beige hover:text-dark-primary text-brand-beige font-semibold rounded-lg transition hover-lift font-manrope text-sm md:text-base"
                    >
                      Apply Now
                    </Link>
                  </div>
                </div>
              </div>
            </section>

            <section className="w-full bg-grey-blue flex flex-wrap">
              {[
                {
                  link: "/igcse",
                  alt: "IGCSE",
                  src: "https://bic-bangkok.vercel.app/IGCSE.jpg",
                },
                {
                  link: '/alevels',
                  alt: "A Levels",
                  src: "https://bic-bangkok.vercel.app/alevels.jpg",
                },
                {
                 link: "/ossd" ,
                  alt: "OSSD",
                  src: "https://bic-bangkok.vercel.app/ossd.jpg",
                },
                {
                  link: '/ged',
                  alt: "GED",
                  src: "https://bic-bangkok.vercel.app/ged.jpg",
                },
                {
                  link: '/ncuk',
                  alt: "NCUK",
                  src: "https://www.bi-bangkok.com/ncuk.jpg",
                },
                {
                  link: '/university-21',
                  alt: "University (2+1)",
                  src: "https://bic-bangkok.vercel.app/un.png"
                }
              ].map(({ alt, src, link }) => (
                <div
                  key={alt}
                  onClick={()=> {
                    navigate(`${link}`)
                  }}
                  className="w-1/2 md:w-1/6 p-2 bg-grey-blue flex justify-center items-center filter filter grayscale-[40%]  hover:grayscale-0 transition duration-300"
                >
                  <img
                    src={src || "/placeholder.svg"}
                    alt={alt}
                    className="max-w-full max-h-33 object-contain"
                    loading="lazy"
                  />
                </div>
              ))}
            </section>

            <section className="w-full flex flex-col md:flex-row items-stretch">
              {/* Left side: just an image */}
              <div className="w-full md:w-1/2">
                <img
                  // src="https://tse1.mm.bing.net/th/id/OIP.C4y-ifG4Ft1ZZwi0vEepVgHaFD?rs=1&pid=ImgDetMain&o=7&rm=3"
                  src="https://bic-bangkok.vercel.app/crowd1.jpg"
                  alt="What we offer"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Right side: background image + overlay + text */}
              <div
                className="w-full md:w-1/2 relative bg-cover bg-center"
                style={{
                  backgroundImage:
                    "url('https://bic-bangkok.vercel.app/accommodation1.jpg')",
                }}
              >
                {/* Darker overlay */}
                <div className="absolute inset-0 bg-black/70 bg-opacity-80"></div>
                {/* Text content */}
                <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
                  <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
                    What We Offer
                  </h2>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    We provide comprehensive educational programs designed to
                    prepare students for success at top international
                    universities. Our expert faculty and proven curriculum
                    ensure exceptional academic outcomes.
                  </p>
                  <ul className="list-disc list-inside font-manrope text-gray-400 max-w-xl space-y-1 text-sm md:text-base">
                    <li className=" text-brand-beige">
                      IGCSE, A Levels, OSSD, and GED programs
                    </li>
                    <li className=" text-brand-beige">
                      University application guidance and support
                    </li>
                    <li className=" text-brand-beige">
                      Small class sizes with personalized attention
                    </li>
                    <li className=" text-brand-beige">
                      International faculty with proven expertise
                    </li>
                  </ul>
                  <div className="flex flex-col sm:flex-row gap-3 md:gap-4 pt-4">
                    <Link
                      to="/programs"
                      className="px-4 text-center  md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
                    >
                      View Programs
                    </Link>
                    <Link
                      to="/admissions"
                      className="px-4 text-center md:px-6 py-2 md:py-3 bg-transparent border border-brand-beige hover:bg-brand-beige hover:text-dark-primary text-brand-beige font-semibold rounded-xl transition hover-lift font-manrope text-sm md:text-base"
                    >
                      Apply Now
                    </Link>
                  </div>
                </div>
              </div>
            </section>

            <section className="w-full flex flex-col md:flex-row-reverse items-stretch">
              {/* Right side: image */}
              <div className="w-full md:w-1/2">
                <img
                  src="https://bic-bangkok.vercel.app/lib.jpg"
                  alt="What we offer"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Left side: text with bg-white/40 */}
              <div className="w-full md:w-1/2 bg-dark-blue flex flex-col justify-center p-6 md:p-10 space-y-4 md:space-y-6">
                <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
                  University Preparation at BI
                </h2>
                <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                  At BI, we are committed to fostering academic excellence
                  through our rigorous University preparation programmes:{" "}
                  <strong className=" text-brand-red">GED</strong>,{" "}
                  <strong className=" text-brand-red">IGCSE</strong>, and
                  <strong className=" text-brand-red"> A Levels</strong> — all
                  tailored for students aiming to get into top international
                  universities.
                </p>
                <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                  Our vibrant campus, expert faculty, and cultural immersion
                  opportunities make BI the perfect place to achieve your
                  academic goals and prepare for a global future.
                </p>
              </div>
            </section>

        

{/* NCUK Study Centre Section */}
<section className="w-full flex flex-col md:flex-row bg-dark-blue  items-stretch">
  {/* Left side - Big Image */}
  <div className="w-full md:w-1/2">
    <img
      src="https://bic-bangkok.vercel.app/studyCenter.jpg"
      alt="NCUK Study Centre"
      className="w-full h-full object-cover min-h-[400px] md:min-h-[500px]"
    />
  </div>

{/* Text content */}
<div className="relative z-10 p-6 md:p-10 flex flex-col bg-dark-blue  justify-center h-full">

  {/* Logo + Badge */}
  <div className="flex flex-wrap items-center gap-4 mb-6">
    <img
      src="/centre.png"
      alt="NCUK Logo"
      className="h-12 md:h-16 object-contain flex-shrink-0"
    />

    <div className="px-4 py-1.5 bg-brand-red/20 rounded-full border border-brand-red/40">
      <span className="text-brand-beige font-manrope font-semibold text-xs uppercase tracking-widest">
        Official Study Centre
      </span>
    </div>
  </div>

  {/* Heading */}
  <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige mb-3">
    Official <span className="text-brand-red">NCUK</span> Study Centre
  </h2>

  {/* Partner */}
  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl mb-4">
    in partnership with{" "}
    <span className="text-brand-beige font-semibold">
      Dhurakij Pundit University
    </span>
  </p>

  {/* Description */}
  <p className="text-base md:text-lg font-manrope text-gray-400 max-w-xl leading-relaxed mb-8">
    Bridge International Bangkok is proud to be an official NCUK Study Centre,
    offering students a guaranteed pathway to top universities in the UK,
    Australia, New Zealand, and beyond through our partnership with
    Dhurakij Pundit University.
  </p>

  {/* Buttons */}
  <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
    <Link
      to="/about#ncuk-partnership"
      className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold text-center rounded-lg shadow-md transition hover-lift font-manrope text-sm md:text-base inline-flex items-center justify-center gap-2"
    >
      Read More
      <FiArrowRight className="w-4 h-4" />
    </Link>

  </div>

</div>
</section>


            <section className="w-full flex flex-col md:flex-row items-start py-8 md:py-14 px-4 md:px-6 gap-8 md:gap-12 relative overflow-hidden">
              <div className="w-full md:w-1/2 flex flex-col mt-4 justify-start">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-lora font-semibold text-brand-beige mb-6 md:mb-8">
                  Why Choose Us
                </h2>
                <h3 className="text-xl md:text-2xl font-lora text-brand-beige font-semibold mb-4">
                  Bridge International Bangkok
                </h3>
                <p className="text-gray-300 text-base md:text-lg leading-relaxed font-manrope mb-4 md:mb-6">
                  We offer more than just education — we offer transformation.
                  With an internationally aligned curriculum and a strong
                  emphasis on global citizenship, BI Bangkok empowers students
                  with the knowledge, skills, and confidence to thrive in an
                  ever-changing world.
                </p>
                <p className="text-gray-400 text-sm md:text-base leading-relaxed font-manrope">
                  Our expert educators and inclusive community foster critical
                  thinking, innovation, and a lifelong passion for learning.
                  Choosing BI means choosing a future where every student's
                  potential is unlocked.
                </p>
                {/* Full-width Button on mobile, fit on desktop */}
                <Link
                  to="/about"
                  className="w-full md:w-auto inline-flex justify-center items-center px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-brand-red/90 text-white font-manrope font-semibold rounded-xl transition-all duration-300 shadow-md hover:shadow-brand-red/30 mt-6 md:mt-8 hover-lift text-sm md:text-base"
                >
                  Learn More About Us
                  <svg
                    className="w-4 h-4 md:w-5 md:h-5 ml-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    />
                  </svg>
                </Link>
              </div>
              {/* Right Side - Video only, NO BOX */}
              <div className="w-full md:w-1/2 flex flex-col gap-2">
                {/* Main Video */}
                <div className="aspect-video rounded-xl overflow-hidden bg-dark-primary">
                  <iframe
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/BNA3J24Ed0g"
                    title="BI Welcoming Message"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    className="w-full h-full rounded-lg"
                  />
                </div>
                {/* Thumbnails */}
                <div className="grid grid-cols-3 gap-2 md:gap-3">
                  {["BNA3J24Ed0g", "X2WWn2-_mpM", "4edqha3Tb0k"].map(
                    (id, index) => (
                      <button
                        key={id}
                        onClick={() =>
                          (document.querySelector(
                            "iframe"
                          ).src = `https://www.youtube.com/embed/${id}?autoplay=1`)
                        }
                        className="relative aspect-video rounded-lg overflow-hidden border-2 border-white/20 hover:border-brand-beige transition-all group"
                      >
                        <img
                          src={`https://img.youtube.com/vi/${id}/mqdefault.jpg`}
                          alt={`Video ${index + 1}`}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        />
                        <div className="absolute inset-0 bg-dark-primary/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                          <PlayIcon className="w-4 h-4 md:w-6 md:h-6 text-brand-beige" />
                        </div>
                      </button>
                    )
                  )}
                </div>
              </div>
            </section>

           
     {/* <section className="w-full flex flex-col md:flex-row items-stretch">
              <div className="w-full md:w-1/2">
                <img
                  src="https://bic-bangkok.vercel.app/IGCSE.jpg"
                  alt="IGCSE Program"
                  className="w-full h-full object-cover"
                />
              </div>
              <div
                className="w-full md:w-1/2 relative bg-cover bg-center"
                style={{
                  backgroundImage: "url('./igcse-bg.jpg')",
                }}
              >
                <div className="absolute inset-0 bg-white/40 bg-opacity-80"></div>
                <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
                  <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
                    IGCSE
                  </h2>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    Engaging students through discussions, group projects, and
                    practical applications. Our IGCSE program provides a solid
                    foundation for advanced studies with internationally
                    recognized qualifications.
                  </p>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    Students develop critical thinking skills and gain
                    comprehensive knowledge across multiple subjects, preparing
                    them for A Levels and university entrance.
                  </p>
                  <div className="flex flex-wrap gap-4 pt-4">
                    <Link
                      to="/igcse"
                      className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
                    >
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </section> */}

{/*             <section className="w-full flex flex-col-reverse md:flex-row items-stretch">
              <div
                className="w-full md:w-1/2 relative bg-cover bg-center"
                style={{
                  backgroundImage: "url('./ossd-bg.jpg')",
                }}
              >
                <div className="absolute inset-0 bg-white/40 bg-opacity-80"></div>
                <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
                  <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
                    OSSD
                  </h2>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    With small class sizes, our teachers focus on the unique
                    needs of each student. The Ontario Secondary School Diploma
                    offers a flexible pathway to Canadian and international
                    universities.
                  </p>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    Students benefit from personalized attention and a
                    curriculum that emphasizes both academic excellence and
                    practical skills development.
                  </p>
                  <div className="flex flex-wrap gap-4 pt-4">
                    <Link
                      to="/ossd"
                      className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
                    >
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <img
                  src="https://bic-bangkok.vercel.app/ossd.jpg"
                  alt="OSSD Program"
                  className="w-full h-full object-cover"
                />
              </div>
            </section> */}

{/*             <section className="w-full flex flex-col md:flex-row items-stretch">
              <div className="w-full md:w-1/2">
                <img
                  src="https://bic-bangkok.vercel.app/alevels.jpg"
                  alt="A Levels Program"
                  className="w-full h-full object-cover"
                />
              </div>
              <div
                className="w-full md:w-1/2 relative bg-cover bg-center"
                style={{
                  backgroundImage: "url('./alevels-bg.jpg')",
                }}
              >
                <div className="absolute inset-0 bg-white/40 bg-opacity-80"></div>
                <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
                  <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
                    A Levels
                  </h2>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    Read about the achievements of our students who have gone on
                    to study at prestigious universities around the world. Our A
                    Levels program is the gold standard for university
                    preparation.
                  </p>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    Students pursue in-depth study in their chosen subjects,
                    developing the analytical and research skills essential for
                    university success.
                  </p>
                  <div className="flex flex-wrap gap-4 pt-4">
                    <Link
                      to="/alevels"
                      className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
                    >
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </section> */}

{/*             <section className="w-full flex flex-col-reverse md:flex-row items-stretch">
              <div
                className="w-full md:w-1/2 relative bg-cover bg-center"
                style={{
                  backgroundImage: "url('./ged-bg.jpg')",
                }}
              >
                <div className="absolute inset-0 bg-white/40 bg-opacity-80"></div>
                <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
                  <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
                    GED
                  </h2>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    Flexible pathway for adult learners seeking to complete
                    their high school equivalency and advance to higher
                    education. Our GED program accommodates working
                    professionals and non-traditional students.
                  </p>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    With flexible scheduling and comprehensive support, students
                    can achieve their educational goals while balancing other
                    life commitments.
                  </p>
                  <div className="flex flex-wrap gap-4 pt-4">
                    <Link
                      to="/ged"
                      className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
                    >
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <img
                  src="https://bic-bangkok.vercel.app/ged.jpg"
                  alt="GED Program"
                  className="w-full h-full object-cover"
                />
              </div>
            </section> */}

{/*             <section className="w-full flex flex-col md:flex-row items-stretch">
              <div className="w-full md:w-1/2">
                <img
                  src="/ncuk.jpg"
                  alt="NCUK Program"
                  className="w-full h-full object-cover"
                />
              </div>
              <div
                className="w-full md:w-1/2 relative bg-cover bg-center"
                style={{
                  backgroundImage: "url('./ncuk-bg.jpg')",
                }}
              >
                <div className="absolute inset-0 bg-white/40 bg-opacity-80"></div>
                <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
                  <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
                    NCUK
                  </h2>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    The NCUK International Foundation Year is your gateway to
                    top-ranked universities in the UK and worldwide. Designed in
                    partnership with leading institutions, it ensures students
                    are fully prepared for undergraduate study abroad.
                  </p>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    Through a mix of academic excellence, English language
                    development, and university preparation, NCUK provides a
                    trusted pathway for ambitious students aiming to succeed
                    internationally.
                  </p>
                  <div className="flex flex-wrap gap-4 pt-4">
                    <Link
                      to="/ncuk"
                      className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
                    >
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </section> */}

{/*             <section className="w-full flex flex-col-reverse md:flex-row items-stretch">
  <div className="w-full md:w-2/5 relative">
    <div className="absolute inset-0 bg-white/40 bg-opacity-80"></div>
    <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
      <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
        University (2+1) Program
      </h2>
      <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
The University (2+1) Program lets students earn a UK Bachelor's degree from the University of Sunderland while studying entirely in Bangkok.
      </p>
      <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
     Students learn in an international campus environment with experienced global faculty, modern classrooms, and small class sizes that allow for closer guidance and personal academic support.
      </p>
      <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
This program is perfect for students who want a globally recognized UK degree, an exciting international university experience, and a smart, affordable path toward a successful global career.
      </p>
      <div className="flex flex-wrap gap-4 pt-4">
        <Link
          to="/university-program"
          className="px-4 md:px-6 py-2 md:py-3 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-sm md:text-base"
        >
          Learn More
        </Link>
      </div>
    </div>
  </div>
  <div className="w-full md:w-3/5">
    <img
      src="https://bic-bangkok.vercel.app/un.png"
      alt="University Program"
      className="w-full h-full object-cover"
    />
  </div>
</section> */}


            {/* Why Bangkok Section */}
            <section className="w-full">
              <div
                className="w-full relative bg-cover bg-center py-12 md:py-20"
                style={{
                  backgroundImage: "url('./bangkok-bg.jpg')",
                }}
              >
                {/* Darker overlay */}
                <div className="absolute inset-0 bg-dark-blue bg-opacity-80"></div>
                {/* Text content - centered */}
                <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center space-y-6 md:space-y-8">
                  <h2 className="text-3xl md:text-5xl font-lora font-semibold leading-tight text-brand-beige">
                    Why Bangkok?
                  </h2>
                  <div className="space-y-6 max-w-3xl mx-auto">
                    <div className="flex items-start space-x-4 text-left">
                      <div className="w-3 h-3 bg-brand-red rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-lg md:text-xl font-manrope text-gray-300">
                        Bangkok offers a{" "}
                        <span className="text-brand-beige font-semibold">
                          safe, accessible, and culturally familiar environment
                        </span>
                        , making it the perfect first step for Myanmar students.
                      </p>
                    </div>
                    <div className="flex items-start space-x-4 text-left">
                      <div className="w-3 h-3 bg-brand-red rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-lg md:text-xl font-manrope text-gray-300">
                        It allows them to{" "}
                        <span className="text-brand-beige font-semibold">
                          build independence and adapt gradually
                        </span>{" "}
                        before transitioning to the UK.
                      </p>
                    </div>
                    <div className="flex items-start space-x-4 text-left">
                      <div className="w-3 h-3 bg-brand-red rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-lg md:text-xl font-manrope text-gray-300">
                        With its{" "}
                        <span className="text-brand-beige font-semibold">
                          close proximity, parents can easily visit
                        </span>
                        , offering added peace of mind.
                      </p>
                    </div>
                    <div className="flex items-start space-x-4 text-left">
                      <div className="w-3 h-3 bg-brand-red rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-lg md:text-xl font-manrope text-gray-300">
                        As a{" "}
                        <span className="text-brand-beige font-semibold">
                          modern, global city with regional comfort
                        </span>
                        , Bangkok serves as an ideal launchpad for students to
                        grow academically and personally on their international
                        journey.
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-wrap justify-center gap-4 pt-6">
                    {/* <Link
                      to="/about"
                      className="px-6 md:px-8 py-3 md:py-4 bg-brand-red hover:bg-red-700 text-white font-semibold rounded-xl shadow-md transition hover-lift font-manrope text-base md:text-lg"
                    >
                      Discover More
                    </Link> */}
                    <Link
                      to="/enquire"
                      className="px-6 md:px-8 py-3 md:py-4 bg-transparent border border-brand-beige hover:bg-brand-beige hover:text-dark-primary text-brand-beige font-semibold rounded-xl transition hover-lift font-manrope text-base md:text-lg"
                    >
                      Contact Us
                    </Link>
                  </div>
                </div>
              </div>
            </section>

            {/* LEARN FROM THE BEST AT BI - Modern Card Layout */}


<section
  className="w-full py-16 md:py-24 px-4 md:px-6 relative"
  style={{ backgroundImage: "url('./shirt.jpg')" }}
>
  {/* Darker gray gradient overlay */}
  <div className="absolute inset-0 bg-gradient-to-br from-gray-900/90 via-black-900/85 to-gray-950/90"></div>
  
  {/* Subtle texture */}
  <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_1px_1px,rgba(255,255,255,0.1)_1px,transparent_0)] bg-[size:40px_40px]"></div>

  <div className="relative z-10 max-w-7xl mx-auto">
    {/* Header */}
    <div className="text-center mb-16">
      <div className="inline-block mb-4 px-4 py-2 bg-brand-red/30 backdrop-blur-sm rounded-lg border border-brand-red/40">
        <span className="text-brand-beige font-manrope font-semibold text-sm uppercase tracking-wider">
          Faculty Excellence
        </span>
      </div>
      <h1 className="text-4xl md:text-5xl font-lora font-bold text-gray-300 mb-4 drop-shadow-lg">
        LEARN FROM OUR EXPERT FACULTY
      </h1>
      <div className="w-24 h-1 bg-brand-beige mx-auto mb-6"></div>
      <p className="text-lg md:text-2xl font-manrope font-bold text-brand-beige leading-relaxed max-w-4xl mx-auto drop-shadow-md">
        World-class educators dedicated to your academic success
      </p>
    </div>

    {/* Featured Teachers - Full Information */}
    <div className="space-y-12 mb-16">
  

      {/* Mr. Iqbal */}
      <div className="group bg-gray-950 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-gray-700/60 hover:border-brand-beige/50 transition-all duration-300 shadow-2xl shadow-black/50">
        <div className="flex flex-col md:flex-row md:items-start gap-6 mb-6">
          <div className="md:w-1/4">
            <div className="relative">
              <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden border-2 border-brand-beige/60 mx-auto md:mx-0 shadow-xl bg-gray-700 p-1">
                <img
                  src="https://bic-bangkok.vercel.app/teachers/Mr.%20Iqbal.jpg"
                  alt="Mr. Iqbal"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300 rounded-full"
                />
              </div>
              <div className="absolute top-0 right-0 md:right-4 bg-brand-red text-white px-4 py-1.5 rounded-full text-sm font-bold shadow-lg">
                Featured
              </div>
            </div>
          </div>
          <div className="md:w-3/4">
            <div className="flex flex-col sm:flex-row sm:items-center mb-3">
              <h2 className="text-2xl md:text-3xl font-lora font-semibold text-brand-beige">Mr. Iqbal</h2>
              <div className="flex items-center mt-2 sm:mt-0 sm:ml-4 space-x-2">
                <span className="px-3 py-1 bg-blue-500/40 text-blue-300 text-xs font-bold rounded-full">Oxford</span>
                <span className="px-3 py-1 bg-gray-700 text-gray-300 text-xs rounded-full">3+ Years Exp</span>
              </div>
            </div>
            <p className="text-xl text-gray-400 font-manrope mb-6">Biology Teacher</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Qualifications */}
              <div>
                <h3 className="text-lg font-semibold text-gray-300 mb-3 pb-2 border-b border-gray-700 flex items-center">
                  <FiBook className="w-5 h-5 mr-2 text-brand-beige" />
                  Qualifications
                </h3>
                <ul className="space-y-3">
                  {teachers[0].qualifications.map((qual, index) => (
                    <li key={index} className="flex items-start group hover:bg-gray-700/50 p-2 rounded-lg transition-colors">
                      <div className="w-5 h-5 bg-brand-red/30 rounded-full flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                        <span className="text-brand-beige text-xs">✓</span>
                      </div>
                      <span className="text-gray-400 group-hover:text-gray-300 transition-colors">{qual}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              {/* Experience */}
              <div>
                <h3 className="text-lg font-semibold text-gray-300 mb-3 pb-2 border-b border-gray-700 flex items-center">
                  <FiBriefcase className="w-5 h-5 mr-2 text-blue-400" />
                  Experience
                </h3>
                <ul className="space-y-3">
                  {teachers[0].experience.map((exp, index) => (
                    <li key={index} className="flex items-start group hover:bg-gray-700/50 p-2 rounded-lg transition-colors">
                      <div className="w-5 h-5 bg-blue-500/30 rounded-full flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                        <span className="text-blue-300 text-xs">★</span>
                      </div>
                      <span className="text-gray-400 group-hover:text-gray-300 transition-colors">{exp}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>

    {/* All Other Teachers */}
    <div className="mb-12">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {teachers.slice(0).filter((_, i) => i !== 0).map((teacher, index) => (
          <div key={index} className="group bg-gray-950 rounded-xl p-5 border border-gray-700/60 hover:border-brand-beige/30 transition-all duration-300 hover:translate-y-[-2px] shadow-lg shadow-black/30">
            <div className="flex items-start gap-4 mb-4">
              <div className="relative">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-gray-700 overflow-hidden border border-gray-600 group-hover:border-brand-beige/30 transition-colors">
                  <img
                    src={teacher.image}
                    alt={teacher.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                {teacher.name.includes('Dr.') && (
                  <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-brand-red rounded-full flex items-center justify-center border border-white shadow-md">
                    <span className="text-white text-xs font-bold">D</span>
                  </div>
                )}
              </div>
              <div className="flex-1">
                <h3 className="text-lg md:text-xl font-lora font-semibold text-brand-beige mb-1">{teacher.name}</h3>
                <p className="text-gray-400 font-manrope text-sm mb-3">{teacher.occupation}</p>
                
                {/* Quick Qualifications */}
                <div className="mb-3">
                  <div className="flex items-center text-gray-400 mb-2">
                    <FiBook className="w-3 h-3 mr-1" />
                    <span className="text-xs font-semibold">Top Qualifications</span>
                  </div>
                  <div className="space-y-1.5">
                    {teacher.qualifications.map((qual, qIndex) => (
                      <div key={qIndex} className="flex items-start">
                        <div className="w-1.5 h-1.5 bg-brand-beige rounded-full mt-1.5 mr-2 flex-shrink-0"></div>
                        <span className="text-gray-400 text-xs">{qual}</span>
                      </div>
                    ))}
                  </div>
                </div>
                
                {/* Quick Experience */}
                {teacher.experience.length > 0 && (
                  <div>
                    <div className="flex items-center text-gray-400 mb-2">
                      <FiBriefcase className="w-3 h-3 mr-1" />
                      <span className="text-xs font-semibold">Experience</span>
                    </div>
                    <div className="space-y-1.5">
                      {teacher.experience.map((exp, eIndex) => (
                        <div key={eIndex} className="flex items-start">
                          <div className="w-1.5 h-1.5 bg-blue-400 rounded-full mt-1.5 mr-2 flex-shrink-0"></div>
                          <span className="text-gray-400 text-xs">{exp}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {/* Stats */}
            <div className="pt-4 border-t border-gray-700 mt-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="flex items-center text-gray-400 mr-3">
                    <FiAward className="w-3 h-3 mr-1" />
                    <span className="text-xs">{teacher.qualifications.length} Quals</span>
                  </div>
                  {teacher.experience.length > 0 && (
                    <div className="flex items-center text-gray-400">
                      <FiClock className="w-3 h-3 mr-1" />
                      <span className="text-xs">{teacher.experience.length} Roles</span>
                    </div>
                  )}
                </div>
                {teacher.qualifications.some(q => q.includes('MBA')) && (
                  <span className="px-2 py-0.5 bg-green-500/30 text-green-300 text-xs font-bold rounded">MBA</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>



  </div>
</section>
            <section className="w-full flex flex-col md:flex-row items-stretch">
              {/* Left side: background image + gray overlay + text */}
              <div
                className="w-full md:w-1/2 relative bg-gray-900  bg-center"
                // style={{
                //   backgroundImage: "url('./memories.webp')",
                // }}
              >
                {/* Gray overlay */}
                <div className="absolute inset-0  bg-opacity-80"></div>

                {/* Text content */}
                <div className="relative z-10 p-6 md:p-10 flex flex-col justify-center h-full space-y-4 md:space-y-6">
                  <h2 className="text-2xl md:text-4xl font-lora font-semibold leading-tight text-brand-beige">
                    Trust in Our Expertise
                  </h2>
                  <p className="text-base md:text-lg font-manrope text-gray-300 max-w-xl">
                    Our teaching methodology is designed to build confidence,
                    encourage critical thinking, and foster a love of learning.
                    At BI, your success is our mission.
                  </p>
                </div>
              </div>

              {/* Right side: just an image */}
              <div className="w-full md:w-1/2">
                <img
                  src="https://bic-bangkok.vercel.app/trust.jpg"
                  alt="Trust Image"
                  className="w-full h-full object-cover"
                />
              </div>
            </section>



<section
  ref={carouselRef}
  className="w-full py-20 md:py-28 overflow-hidden"
  style={{ background: "#080b12" }}
>
  {/* Header */}
  <div className="text-center mb-14 px-6">
    <div className="inline-block mb-4 px-4 py-1.5 bg-brand-red/20 rounded-full border border-brand-red/40">
      <span className="text-brand-beige font-manrope font-semibold text-xs uppercase tracking-widest">
        Student Success
      </span>
    </div>

    <h2 className="text-4xl md:text-5xl lg:text-6xl font-lora font-semibold text-brand-beige mb-4">
      Bridge <span className="text-brand-red">Hero</span> Success
    </h2>

    <div className="w-16 h-1 bg-brand-red mx-auto mb-4 rounded-full" />

    <p className="text-gray-500 font-manrope text-sm md:text-base max-w-xl mx-auto leading-relaxed">
      Our graduates are making their mark at world-class universities across
      the globe.
    </p>
  </div>

  {/* Carousel */}
  <div className="overflow-hidden w-full">
    <div
      className="flex items-center transition-transform duration-[1000ms] ease-[cubic-bezier(.22,1,.36,1)]"
style={{
  transform: `translateX(calc(50vw - ${
    (currentSlide + 0.5) * (window.innerWidth >= 1024 ? 30 : 80)
  }vw))`,
}}
    >
   {students.map((student, idx) => (
  <div
    key={student.name}
    className="flex-shrink-0 w-[80vw] lg:w-[30vw] px-4 cursor-pointer"
    onClick={() => setCurrentSlide(idx)}
  >
    <div
      className="relative w-full aspect-[4/5] rounded-3xl overflow-hidden transition-all duration-700 hover:scale-[1.02]"
      style={{
        transform:
          idx === currentSlide
            ? "scale(1)"
            : Math.abs(idx - currentSlide) === 1
            ? "scale(0.94)"
            : "scale(0.9)",

        opacity:
          idx === currentSlide
            ? 1
            : Math.abs(idx - currentSlide) === 1
            ? 0.75
            : 0.5,

        boxShadow:
          idx === currentSlide
            ? "0 30px 80px rgba(185,28,28,.35)"
            : "0 10px 40px rgba(0,0,0,.3)",
      }}
    >
      <img
        src={student.image}
        alt={student.name}
        className="absolute inset-0 w-full h-full object-cover object-top"
        onError={(e) => {
          e.target.style.display = "none";
        }}
      />

      <div
        className="absolute inset-0"
        style={{
          background: `
            linear-gradient(
              to bottom,
              rgba(0,0,0,0) 10%,
              rgba(0,0,0,.15) 35%,
              rgba(0,0,0,.75) 70%,
              rgba(0,0,0,.98) 100%
            )
          `,
        }}
      />

      <div className="absolute bottom-0 left-0 right-0 z-10 p-6 md:p-10 lg:p-12">
        <h3 className="font-lora font-semibold text-white text-3xl md:text-4xl lg:text-5xl mb-4">
          {student.name}
        </h3>

        <div className="flex flex-wrap gap-2 mb-5">
          <span className="bg-brand-red text-white text-xs md:text-sm font-manrope font-bold px-4 py-2 rounded-full">
            {student.program}
          </span>

          <span className="bg-white/10 border border-white/20 text-white/80 text-xs md:text-sm font-manrope px-4 py-2 rounded-full">
            Batch {student.batch}
          </span>

         {
          student.pathway != "" &&  <span className="bg-brand-beige/20 border border-brand-beige/30 text-brand-beige text-xs md:text-sm font-manrope px-4 py-2 rounded-full">
            {student.pathway}
          </span>
         }
        </div>

        <div className="flex flex-wrap gap-3">
     {student.universities.map((uni) => (
  <div
    key={uni.name}
    className="group relative w-16 h-16 overflow-hidden rounded-xl bg-white border border-gray-200 hover:border-brand-red/40 hover:shadow-lg hover:shadow-brand-red/10 hover:scale-105 transition-all duration-300"
  >
    <img
      src={uni.logo}
      alt={uni.name}
      className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
      onError={(e) => {
        e.target.style.display = "none";
        e.target.nextSibling.style.display = "flex";
      }}
    />

    {/* Fallback */}
    <div className="hidden absolute inset-0 items-center justify-center bg-white p-1">
      <span className="text-[8px] text-center font-medium text-gray-700 leading-tight">
        {uni.name}
      </span>
    </div>

    {/* Hover Overlay */}
    <div className="absolute inset-0 bg-brand-red/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
  </div>
))}
        </div>
      </div>
    </div>
  </div>
))}
    </div>
  </div>


</section>

            {/* Activities Section */}
            <section className="py-16 md:py-24 bg-dark-blue relative overflow-hidden">
              <div className="absolute inset-0">
                <div className="absolute top-20 left-10 w-32 h-32 bg-brand-red/10 rounded-full blur-3xl"></div>
                <div className="absolute bottom-20 right-10 w-40 h-40 bg-brand-beige/10 rounded-full blur-3xl"></div>
                <div className="absolute top-1/2 left-1/4 w-2 h-20 bg-brand-red/20 rotate-45 rounded-full"></div>
                <div className="absolute bottom-1/3 right-1/3 w-16 h-2 bg-brand-beige/20 rounded-full"></div>
              </div>

              <div className="container mx-auto px-4 relative z-10">
            

                <div className="mt-12 md:mt-16">
                  <div className="text-center mb-8">
                    <h3 className="text-2xl md:text-3xl font-lora font-semibold text-white mb-2">
                      Discover the BI{" "}
                      <span className="text-brand-red">Experience</span>
                    </h3>
                    <p className="text-gray-400 text-sm md:text-base">
                      Explore our world-class facilities and vibrant spaces, 
                      <span className="text-brand-red font-medium">
                       designed to inspire your academic and personal journey.
                      </span>{" "}
                   
                    </p>
                  </div>



{/* <div className="mt-12 md:mt-16">
  <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8 md:mb-10">
    {["All", "Campus Grounds", "Library & Study Spaces", "Sports Facilities", "Modern Classrooms", "Canteen & Dining", "Boarding Facilities"].map((category) => {
      const categoryKey = category === "All" ? "all" : 
        category === "Campus Grounds" ? "campus" :
        category === "Library & Study Spaces" ? "library" :
        category === "Sports Facilities" ? "sports" :
        category === "Modern Classrooms" ? "classrooms" :
        category === "Canteen & Dining" ? "canteen" : "boarding";
      
      return (
        <button
          key={category}
          onClick={() => setActiveCategory(categoryKey)}
          className={`px-4 md:px-6 py-2 md:py-2.5 rounded-full text-sm md:text-base font-manrope font-medium transition-all duration-300 ${
            activeCategory === categoryKey
              ? "bg-brand-red text-white shadow-lg shadow-brand-red/30"
              : "bg-gray-800/60 text-gray-300 hover:bg-gray-700/60 hover:text-white border border-gray-700"
          }`}
        >
          {category}
        </button>
      );
    })}
  </div>

  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4 max-w-7xl mx-auto">
    {(() => {
      const allImages = [
        { src: "campus/campus1.jpg", category: "campus", label: "Campus Grounds" },
        { src: "campus/campus2.jpg", category: "campus", label: "Campus Grounds" },
        { src: "campus/campus3.jpg", category: "campus", label: "Campus Grounds" },
        { src: "campus/campus4.jpg", category: "campus", label: "Campus Grounds" },
        { src: "campus/campus5.jpg", category: "campus", label: "Campus Grounds" },
            { src: "campus/campus6.jpg", category: "campus", label: "Campus Grounds" },
        { src: "campus/campus7.jpg", category: "campus", label: "Campus Grounds" },
        { src: "campus/campus8.jpg", category: "campus", label: "Campus Grounds" },
        { src: "library1.jpg", category: "library", label: "Library & Study Spaces" },
        { src: "library/library2.jpg", category: "library", label: "Library & Study Spaces" },
        { src: "library3.jpg", category: "library", label: "Library & Study Spaces" },
        {src: "library/library4.jpg", category: "library", "label":"Library & Study Spaces"},
          { src: "library/library5.jpg", category: "library", label: "Library & Study Spaces" },
        { src: "library/library6.jpg", category: "library", label: "Library & Study Spaces" },
        { src: "library/library7.jpg", category: "library", label: "Library & Study Spaces" },
        {src: "library/library8.jpg", category: "library", "label":"Library & Study Spaces"},
        { src: "sports/sports1.jpg", category: "sports", label: "Sports Facilities" },
        { src: "sports/sports2.jpg", category: "sports", label: "Sports Facilities" },
        { src: "sports/sports3.jpg", category: "sports", label: "Sports Facilities" },
       { src: "sports/sports4.jpg", category: "sports", label: "Sports Facilities" },
        { src: "sports/sports5.jpg", category: "sports", label: "Sports Facilities" },
         { src: "sports/sports6.jpg", category: "sports", label: "Sports Facilities" },
        { src: "class/classroom1.jpg", category: "classrooms", label: "Modern Classrooms" },
        { src: "class/classroom2.jpg", category: "classrooms", label: "Modern Classrooms" },
        { src: "class/classroom3.jpg", category: "classrooms", label: "Modern Classrooms" },
         { src: "class/classroom4.jpg", category: "classrooms", label: "Modern Classrooms" },
        { src: "canteen/canteen1.jpg", category: "canteen", label: "Canteen & Dining" },
        { src: "canteen/canteen2.jpg", category: "canteen", label: "Canteen & Dining" },
        { src: "canteen/canteen3.jpg", category: "canteen", label: "Canteen & Dining" },
        { src: "canteen/canteen4.jpg", category: "canteen", label: "Canteen & Dining" },
        { src: "canteen/canteen5.jpg", category: "canteen", label: "Canteen & Dining" },
        { src: "boarding/boarding1.jpg", category: "boarding", label: "Boarding Facilities" },
        { src: "boarding/boarding2.jpg", category: "boarding", label: "Boarding Facilities" },
        { src: "boarding/boarding3.jpg", category: "boarding", label: "Boarding Facilities" },
         { src: "boarding/boarding4.jpg", category: "boarding", label: "Boarding Facilities" },
          { src: "boarding/boarding5.jpg", category: "boarding", label: "Boarding Facilities" },
      ];

      const filteredImages = activeCategory === "all" 
        ? allImages 
        : allImages.filter(img => img.category === activeCategory);

      return filteredImages.map((image, index) => (
        <div
          key={index}
          className="group relative aspect-square overflow-hidden rounded-xl bg-gray-800/50 border border-white/10 hover:border-brand-beige/50 transition-all duration-500 cursor-pointer"
          onClick={() => {
            console.log(`Clicked: ${image.src}`);
          }}
        >
          <img
            src={`https://bic-bangkok.vercel.app/${image.src}`}
            alt={image.label}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            onError={(e) => {
              e.target.src = "https://bic-bangkok.vercel.app/placeholder.jpg";
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 opacity-0 group-hover:opacity-100">
            <p className="text-white text-xs md:text-sm font-manrope font-medium truncate">
              {image.label}
            </p>
          </div>
        </div>
      ));
    })()}
  </div>

<br /><br />
</div> */}


{/* Categorized Image Gallery Section */}
<div className="mt-12 mb-12 md:mt-16">
  <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8 md:mb-10">
    {["All", "Campus Grounds", "Library & Study Spaces", "Sports Facilities", "Modern Classrooms", "Canteen & Dining", "Boarding Facilities"].map((category) => {
      const categoryKey = category === "All" ? "all" : 
        category === "Campus Grounds" ? "campus" :
        category === "Library & Study Spaces" ? "library" :
        category === "Sports Facilities" ? "sports" :
        category === "Modern Classrooms" ? "classrooms" :
        category === "Canteen & Dining" ? "canteen" : "boarding";
      
      return (
        <button
          key={category}
          onClick={() => setActiveCategory(categoryKey)}
          className={`px-4 md:px-6 py-2 md:py-2.5 rounded-full text-sm md:text-base font-manrope font-medium transition-all duration-300 ${
            activeCategory === categoryKey
              ? "bg-brand-red text-white shadow-lg shadow-brand-red/30"
              : "bg-gray-800/60 text-gray-300 hover:bg-gray-700/60 hover:text-white border border-gray-700"
          }`}
        >
          {category}
        </button>
      );
    })}
  </div>

  <div className="max-w-7xl mx-auto">
    {(() => {
      const allImages = [
        { src: "campus/campus1.jpg", category: "campus", label: "Campus Grounds" },
        { src: "campus/campus2.jpg", category: "campus", label: "Campus Grounds" },
        { src: "campus/campus3.jpg", category: "campus", label: "Campus Grounds" },
        { src: "campus/campus4.jpg", category: "campus", label: "Campus Grounds" },
        { src: "campus/campus5.jpg", category: "campus", label: "Campus Grounds" },
        { src: "campus/campus6.jpg", category: "campus", label: "Campus Grounds" },
        { src: "campus/campus7.jpg", category: "campus", label: "Campus Grounds" },
        { src: "campus/campus8.jpg", category: "campus", label: "Campus Grounds" },
        { src: "library1.jpg", category: "library", label: "Library & Study Spaces" },
        { src: "library/library2.jpg", category: "library", label: "Library & Study Spaces" },
        { src: "library3.jpg", category: "library", label: "Library & Study Spaces" },
        { src: "library/library4.jpg", category: "library", label: "Library & Study Spaces" },
        { src: "library/library5.jpg", category: "library", label: "Library & Study Spaces" },
        { src: "library/library6.jpg", category: "library", label: "Library & Study Spaces" },
        { src: "library/library7.jpg", category: "library", label: "Library & Study Spaces" },
        { src: "library/library8.jpg", category: "library", label: "Library & Study Spaces" },
        { src: "sports/sports1.jpg", category: "sports", label: "Sports Facilities" },
        { src: "sports/sports2.jpg", category: "sports", label: "Sports Facilities" },
        { src: "sports/sports3.jpg", category: "sports", label: "Sports Facilities" },
        { src: "sports/sports4.jpg", category: "sports", label: "Sports Facilities" },
        { src: "sports/sports5.jpg", category: "sports", label: "Sports Facilities" },
        { src: "sports/sports6.jpg", category: "sports", label: "Sports Facilities" },
        { src: "class/classroom1.jpg", category: "classrooms", label: "Modern Classrooms" },
        { src: "class/classroom2.jpg", category: "classrooms", label: "Modern Classrooms" },
        { src: "class/classroom3.jpg", category: "classrooms", label: "Modern Classrooms" },
        { src: "class/classroom4.jpg", category: "classrooms", label: "Modern Classrooms" },
        { src: "canteen/canteen1.jpg", category: "canteen", label: "Canteen & Dining" },
        { src: "canteen/canteen2.jpg", category: "canteen", label: "Canteen & Dining" },
        { src: "canteen/canteen3.jpg", category: "canteen", label: "Canteen & Dining" },
        { src: "canteen/canteen4.jpg", category: "canteen", label: "Canteen & Dining" },
        { src: "canteen/canteen5.jpg", category: "canteen", label: "Canteen & Dining" },
        { src: "boarding/boarding1.jpg", category: "boarding", label: "Boarding Facilities" },
        { src: "boarding/boarding2.jpg", category: "boarding", label: "Boarding Facilities" },
        { src: "boarding/boarding3.jpg", category: "boarding", label: "Boarding Facilities" },
        { src: "boarding/boarding4.jpg", category: "boarding", label: "Boarding Facilities" },
        { src: "boarding/boarding5.jpg", category: "boarding", label: "Boarding Facilities" },
      ];

      const filteredImages = activeCategory === "all" 
        ? allImages 
        : allImages.filter(img => img.category === activeCategory);

      const imageCount = filteredImages.length;

      // Determine grid columns based on count
      let gridCols = "grid-cols-2 sm:grid-cols-3 md:grid-cols-4";
      
      if (imageCount <= 2) {
        gridCols = "grid-cols-1 sm:grid-cols-2";
      } else if (imageCount <= 4) {
        gridCols = "grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4";
      } else if (imageCount <= 6) {
        gridCols = "grid-cols-2 sm:grid-cols-2 md:grid-cols-3";
      } else if (imageCount <= 8) {
        gridCols = "grid-cols-2 sm:grid-cols-3 md:grid-cols-4";
      } else {
        gridCols = "grid-cols-2 sm:grid-cols-3 md:grid-cols-4";
      }

      // If no images, show a message
      if (imageCount === 0) {
        return (
          <div className="text-center py-12">
            <p className="text-gray-400 font-manrope">No images available for this category</p>
          </div>
        );
      }

      return (
        <div className={`grid ${gridCols} gap-3 md:gap-4`}>
          {filteredImages.map((image, index) => (
            <div
              key={index}
              className="group relative aspect-square overflow-hidden rounded-xl bg-gray-800/50 border border-white/10 hover:border-brand-beige/50 transition-all duration-500 cursor-pointer"
              onClick={() => {
                console.log(`Clicked: ${image.src}`);
              }}
            >
              <img
                src={`https://bic-bangkok.vercel.app/${image.src}`}
                alt={image.label}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                onError={(e) => {
                  e.target.src = "https://bic-bangkok.vercel.app/placeholder.jpg";
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 opacity-0 group-hover:opacity-100">
                <p className="text-white text-xs md:text-sm font-manrope font-medium truncate">
                  {image.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      );
    })()}
  </div>
</div>
              
              
                  <div className="grid md:grid-cols-2 gap-8 md:gap-12 max-w-7xl mx-auto">
                    {videos?.map((video) => (
                      <div key={video.id} className="group relative">
                        <div className="relative">
                          {/* Video iframe */}
                          <div className="relative aspect-video rounded-3xl overflow-hidden bg-gradient-to-br from-gray-800/80 to-gray-900/80 border-2 border-white/10 hover:border-brand-red/60 transition-all duration-700 shadow-2xl hover:shadow-brand-red/20">
                            <iframe
                              src={`https://www.youtube.com/embed/${video.embed_id}`}
                              title={video.title}
                              className="w-full h-full"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                            ></iframe>
                            <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent pointer-events-none"></div>
                            <div className="absolute top-4 right-4 w-3 h-3 bg-brand-red rounded-full opacity-80 animate-pulse"></div>
                          </div>

                          {/* Video description */}
                          <div className="mt-6 text-center">
                            <h4 className="text-xl md:text-2xl font-lora font-bold text-white mb-3 group-hover:text-brand-red transition-colors duration-300">
                              {video.title}
                            </h4>
                            <p className="text-gray-400 text-sm md:text-base leading-relaxed max-w-sm mx-auto">
                              {video.description}
                            </p>
                            <p className="text-gray-500 text-xs mt-2">
                              Uploaded:{" "}
                              {new Date(video.created_at).toLocaleDateString()}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Activity Gallery - keeping existing design */}
                <div className="mt-16 md:mt-20">
                  <div className="text-center mb-12">
                    <h3 className="text-3xl md:text-4xl font-lora font-bold text-brand-red mb-4">
                      Activity Galleries
                    </h3>
                    <p className="text-lg text-gray-300 max-w-2xl mx-auto">
                      Explore the vibrant moments that showcase our dynamic
                      student community and diverse campus experiences
                    </p>
                  </div>

                  {/* Photo Grid */}
                  {galleries.length == 0 && (
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
                      {[1, 2, 3, 4, 5, 6].map((num) => (
                        <div
                          key={num}
                          className="group relative aspect-square overflow-hidden rounded-2xl bg-gray-800/50 border border-white/10 hover:border-brand-beige/50 transition-all duration-500"
                        >
                          <img
                            src={`https://bic-bangkok.vercel.app/act${num}.jpg`}
                            alt={`Student Activity ${num}`}
                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                          <div className="absolute bottom-4 left-4 right-4 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 opacity-0 group-hover:opacity-100">
                            <div className="text-white">
                              <div className="w-8 h-8 bg-brand-red rounded-full flex items-center justify-center mb-2">
                                <div className="w-4 h-4 bg-white rounded-full"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  {galleries.length != 0 && (
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
                      {galleries.map((item) => (
                        <div
                          key={item.id}
                          className="group relative aspect-square overflow-hidden rounded-2xl bg-gray-800/50 border border-white/10 hover:border-brand-beige/50 transition-all duration-500"
                        >
                          <img
                            src={`${new_backend_domain_name}/public/storage/${item.gallery}`}
                            alt={`Gallery ${item.id}`}
                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                          <div className="absolute bottom-4 left-4 right-4 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 opacity-0 group-hover:opacity-100">
                            <div className="text-white">
                              <div className="w-8 h-8 bg-brand-red rounded-full flex items-center justify-center mb-2">
                                <div className="w-4 h-4 bg-white rounded-full"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </section>




            <section className="w-screen relative">
              {/* Full background image */}
              <img
                src="https://bic-bangkok.vercel.app/replace.jpg"
                alt="Trust us to guide your academic journey"
                className="w-screen h-[60vh] md:h-auto object-cover"
              />

              {/* Dark overlay */}
              <div className="absolute inset-0 bg-black/60"></div>

              {/* Text content */}
              <div className="absolute inset-0 flex items-center justify-center px-4 sm:px-6">
                <div className="text-center max-w-3xl space-y-4 sm:space-y-6 md:space-y-8 z-10">
                  <h2 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-lora font-extrabold text-gray-200 leading-snug drop-shadow-lg">
                    Trust Us to Guide Your Academic Journey
                  </h2>
                  <p className="text-base sm:text-lg md:text-2xl font-manrope font-semibold text-brand-beige leading-relaxed drop-shadow-md">
                    Join a community where your success is our priority. We
                    offer personalized learning, state-of-the-art facilities,
                    and a supportive environment that nurtures every student's
                    potential.
                  </p>

                  <Link
                    to="/enquire"
                    className="inline-block bg-brand-red hover:bg-red-700 text-white font-manrope font-bold text-base sm:text-lg md:text-xl px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 shadow-lg transition-all hover:scale-105 rounded-lg sm:rounded-xl"
                  >
                    Apply Now
                  </Link>
                </div>
              </div>
            </section>

            <div className="relative z-10"></div>
          </div>
        )}
      </div>
    </div>
  );
}
